<template>
  <div class="container">
    <div style="width: 1260px; margin: 0 auto; display: flex; height: 100%">
      <div class="tab">
        <div class="tab_title"><common-data name="appShortName_17"/></div>
        <!-- <div class="underline"></div> -->
        <div class="tabtitle">策略研发</div>
        <ul>
          <li
            v-for="(item, index) in contentList1"
            :key="index"
            class="tit-left-item"
            :class="{ active: item.id == id }"
            @click="selectContent(item)"
          >
            <span>{{ item.name }}</span
            >
          </li>
        </ul>
        <div class="tabtitle">模型组合配置</div>
        <ul>
          <li
            v-for="(item, index) in contentList2"
            :key="index"
            class="tit-left-item"
            :class="{ active: item.id == id }"
            @click="selectContent(item)"
          >
            <span>{{ item.name }}</span
            >
          </li>
        </ul>
        <div class="tabtitle">模型的运行</div>
        <ul>
          <li
            v-for="(item, index) in contentList3"
            :key="index"
            class="tit-left-item"
            :class="{ active: item.id == id }"
            @click="selectContent(item)"
          >
            <span>{{ item.name }}</span
            >
          </li>
        </ul>
      </div>
      <div class="content">
        <div class="con-text">
          <div style="box-shadow: 0px 2px 3px 0px rgba(209, 222, 238, 0.9)">
            <div class="text-first" v-if="tabList.length != 0">
              <div class="txt-first">
                <div
                  v-for="(item, index) in tabList"
                  :key="index"
                  class="txt-left-item"
                  @click="choosetag(item.tabId)"
                  :class="{ active: tabId == item.tabId }"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
          <div class="text-txt">
            <div class="wrap" >
              <div v-if="id == 0 && tabId == 0">
                

                <div class="paragraph">
                  <common-data name="appShortName_17"/>提供国内所有期货品种挂牌交易以来全部历史数据，不仅支持k线数据回测，且支持tick级别的模型回测。
                </div>
                <div class="paragraph">
                  数据检验只靠几名数据人员是无法面面俱到的，几百万用户却可以发现任何的一点小错误，百万数量级的用户，才是数据准确性真正的保障！
                </div>

                <div class="first">案例：超长历史k线数据回测</div>
                <div class="first">1、申请海量历史数据的操作方法</div>
                <div class="paragraph">
                  如下图，在主图k线上点击鼠标右键，选择补充历史数据，可以申请该合约不同周期的历史数据供回测使用。
                </div>

                <div class="img_center">
                  <img src="./imageswh9/img1.jpg" />
                </div>

                <div class="first">2、期货合约可申请历史数据的起始时间</div>

                <div class="img_center">
                  <table class="timeTable">
                    <thead>
                      <tr>
                        <th>品种</th>
                        <th>数据起始时间</th>
                        <th>品种</th>
                        <th>数据起始时间</th>
                        <th>品种</th>
                        <th>数据起始时间</th>
                        <th>品种</th>
                        <th>数据起始时间</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>300股指</td>
                        <td>2010/4/16</td>
                        <td>螺纹钢</td>
                        <td>2009/3/27</td>
                        <td>PVC</td>
                        <td>2009/5/25</td>
                        <td>粳稻</td>
                        <td>2013/11/18</td>
                      </tr>
                      <tr>
                        <td>50股指</td>
                        <td>2015/4/16</td>
                        <td>铁矿石</td>
                        <td>2013/10/18</td>
                        <td>BR橡胶</td>
                        <td>2023/7/28</td>
                        <td>晚籼稻</td>
                        <td>2014/7/8</td>
                      </tr>
                      <tr>
                        <td>500股指</td>
                        <td>2015/4/16</td>
                        <td>热卷</td>
                        <td>2014/3/21</td>
                        <td>橡胶</td>
                        <td>1997/4/14</td>
                        <td>豆二</td>
                        <td>2004/12/22</td>
                      </tr>
                      <tr>
                        <td>1000股指</td>
                        <td>2022/7/22</td>
                        <td>不锈钢</td>
                        <td>2019/9/25</td>
                        <td>20号胶</td>
                        <td>2019/8/12</td>
                        <td>豆粕</td>
                        <td>2000/7/17</td>
                      </tr>
                      <tr>
                        <td>二年债</td>
                        <td>2018/8/17</td>
                        <td>线材</td>
                        <td>2018/10/16</td>
                        <td>塑料</td>
                        <td>2007/7/31</td>
                        <td>豆油</td>
                        <td>2006/1/9</td>
                      </tr>
                      <tr>
                        <td>五年债</td>
                        <td>2013/9/6</td>
                        <td>硅铁</td>
                        <td>2014/8/8</td>
                        <td>短纤</td>
                        <td>2020/10/12</td>
                        <td>油菜籽</td>
                        <td>2012/12/28</td>
                      </tr>
                      <tr>
                        <td>十年债</td>
                        <td>2015/3/20</td>
                        <td>锰硅</td>
                        <td>2014/8/8</td>
                        <td>乙二醇</td>
                        <td>2018/12/10</td>
                        <td>菜籽粕</td>
                        <td>2012/12/28</td>
                      </tr>
                      <tr>
                        <td>三十年债</td>
                        <td>2023/4/21</td>
                        <td>焦煤</td>
                        <td>2013/3/22</td>
                        <td>甲醇</td>
                        <td>2011/10/28</td>
                        <td>菜籽油</td>
                        <td>2007/6/8</td>
                      </tr>
                      <tr>
                        <td>沪金</td>
                        <td>2008/7/15</td>
                        <td>焦炭</td>
                        <td>2011/4/15</td>
                        <td>聚丙烯</td>
                        <td>2014/2/28</td>
                        <td>棕榈油</td>
                        <td>2007/10/29</td>
                      </tr>
                      <tr>
                        <td>沪银</td>
                        <td>2012/5/10</td>
                        <td>动力煤</td>
                        <td>2013/9/26</td>
                        <td>苯乙烯</td>
                        <td>2019/9/26</td>
                        <td>花生</td>
                        <td>2021/2/1</td>
                      </tr>
                      <tr>
                        <td>沪铜</td>
                        <td>1996/4/2</td>
                        <td>玻璃</td>
                        <td>2012/12/3</td>
                        <td>尿素</td>
                        <td>2019/8/9</td>
                        <td>棉花</td>
                        <td>2004/6/1</td>
                      </tr>
                      <tr>
                        <td>沪铝</td>
                        <td>1994/10/7</td>
                        <td>纸浆</td>
                        <td>2018/11/27</td>
                        <td>纯碱</td>
                        <td>2019/12/6</td>
                        <td>白糖</td>
                        <td>2006/1/6</td>
                      </tr>
                      <tr>
                        <td>沪锌</td>
                        <td>2007/3/26</td>
                        <td>纤维板</td>
                        <td>2019/12/2</td>
                        <td>对二甲苯</td>
                        <td>2023/9/15</td>
                        <td>棉纱</td>
                        <td>2017/8/18</td>
                      </tr>
                      <tr>
                        <td>沪铅</td>
                        <td>2011/3/24</td>
                        <td>胶合板</td>
                        <td>2013/12/6</td>
                        <td>烧碱</td>
                        <td>2023/9/15</td>
                        <td>鸡蛋</td>
                        <td>2013/11/8</td>
                      </tr>
                      <tr>
                        <td>沪镍</td>
                        <td>2015/3/27</td>
                        <td>原油</td>
                        <td>2018/3/26</td>
                        <td>玉米</td>
                        <td>2004/9/22</td>
                        <td>生猪</td>
                        <td>2021/1/8</td>
                      </tr>
                      <tr>
                        <td>沪锡</td>
                        <td>2015/3/27</td>
                        <td>燃料油</td>
                        <td>2018/7/16</td>
                        <td>豆一</td>
                        <td>2002/3/15</td>
                        <td>苹果</td>
                        <td>2017/12/22</td>
                      </tr>
                      <tr>
                        <td>氧化铝</td>
                        <td>2023/6/19</td>
                        <td>LU燃油</td>
                        <td>2020/6/22</td>
                        <td>淀粉</td>
                        <td>2014/12/19</td>
                        <td>红枣</td>
                        <td>2019/4/30</td>
                      </tr>
                      <tr>
                        <td>国际铜</td>
                        <td>2020/11/19</td>
                        <td>沥青</td>
                        <td>2013/10/9</td>
                        <td>强麦</td>
                        <td>2003/3/28</td>
                        <td>集运欧线</td>
                        <td>2023/8/18</td>
                      </tr>
                      <tr>
                        <td>工业硅</td>
                        <td>2022/12/22</td>
                        <td>液化气</td>
                        <td>2020/3/30</td>
                        <td>粳米</td>
                        <td>2019/8/16</td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>碳酸锂</td>
                        <td>2023/7/21</td>
                        <td>PTA</td>
                        <td>2006/12/18</td>
                        <td>早籼稻</td>
                        <td>2009/4/20</td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="first">
                  3、为什么在【补充数据】中找不到想补充的合约周期
                </div>
                <div class="paragraph">
                  下载列表中所列出的合约周期是基础数据；其他周期的数据由这些基础数据合成，因此，在申请数据的时候只对基础数据做申请。
                </div>
                <br />
                <div class="first">合成原则：</div>
                <div class="paragraph">用tick合成的数据：逐笔回测数据。</div>
                <div class="paragraph">
                  用1秒合成的数据： 量能周期、秒周期，自定义秒周期。
                </div>
                <div class="paragraph">
                  用1分钟合成的数据：15min以下的周期，以及自定义分钟周期。
                </div>
                <div class="paragraph">
                  用15分钟合成的周期：15min，30min，1h，2h，3h，4h，自定义小时周期。
                </div>
                <div class="paragraph">用日线合成的周期：日线及以上周期。</div>
                <br />
                <div class="first">4、如何查看已经交割合约的历史数据</div>
                <div class="paragraph">
                  在K线图界面右键->选择历史年度合约，可以查看到历史年度合约的具体行情数据。
                </div>
              </div>

              <div v-if="id == 0 && tabId == 1">
                <div class="paragraph">
                  有别于传统的加权、主连回测算法，主连链回测是基于期货品种定期换月的特点，而专门研发的独特回测算法。其严谨的利用长期数据验证策略的方法，不再使用品种主连自身的k线数据计算信号，而是采用各个月份合约自挂牌以来的全部k线数据计算信号，规避品种主连k线数据换月跳空、新旧合约趋势相反等情况对量化计算准确性的影响。主力换月时，旧主力月份平仓，新主力根据月份合约的k线数据重新计算开仓信号。
                </div>

                <div class="first">案例：主连链回测机制详解</div>
                <div class="first">1、主连链回测的背景</div>
                <div class="paragraph">
                  主连k线图数据，由各个月份合约的数据拼接形成。把每一个月份合约主力期间以前的k线图砍掉，再把主力期间以后的k线数据砍掉，剩下主力期间的部分k线图，然后按照时间顺序拼接在一起，形成品种主连数据，主连k线数据全局性好，便于看盘了解品种的长期k线价格。
                </div>
                <div class="paragraph">
                  但是这种掐头去尾的处理机制破坏了k线趋势的连续性和完整性，造成主力月份切换时有很大的价格跳空，造成了趋势的失真，尤其是新旧主力合约的走势不一致的情况失真更加严重，不适合直接用于策略回测计算的。
                </div>
                <div class="paragraph">
                  为了给量化投资者提供一个更加真实、客观的回测结果，开创了主连链回测。
                </div>
                <br />
                <div class="first">2、主连链回测的机制</div>
                <div class="paragraph">
                  主连链回测，不是使用你看到的品种主连k线图的数据计算信号的，而是采用主连包含的各个具体月份合约自挂牌以来的全部k线数据计算信号，规避品种主连k线数据换月跳空对量化计算准确性的影响。
                </div>
                <br />
                <div style="font-weight: bolder">适用场景</div>
                <div class="paragraph">
                  针对多个年度的主力月份合约进行连续交易的模型回测计算，用长期的历史数据验证策略的有效性。
                </div>
                <div class="paragraph">
                  主力换月时，回测计算的处理机制如下：
                </div>
                <div class="paragraph">旧主力合约，清仓；</div>
                <div class="paragraph">
                  新主力合约，延续使用旧主力清仓后的资金，但是重新计算信号。
                </div>
                <br />
                <div class="first">
                  3、主图上不显示信号以及原型指标线，怎么去做指标走势对比分析？
                </div>
                <div class="paragraph">
                  右键->回测报告->月份合约k线图，在这里对比分析指标走势，重点K线，压力，支撑线等。因为信号是用具体月份合约的k线图计算的，所以指标走势分析需要在月份k线图上进行。
                </div>
                <div class="paragraph">
                  主连链回测本质上是多个月份合约回测的合并，建议大家研究一个模型的时候，先在某一个具体的月份合约上做回测研究，模型在月份合约上有良好的表现后，再进行主连链回测，对模型进行长期的检测。月份合约的研究就可以在主图上做了，任意加载多个指标对比分析就方便了。
                </div>
              </div>

              <div v-if="id == 0 && tabId == 2">
                <div class="paragraph">
                  <common-data name="appShortName_17"/>基于主连链回测算法提供的回测报告，不仅包含了上百项各类统计数据，还提供了分段回测数据、分项统计、时段统计等专业回测图表，360度检测模型盈利能力及可靠性。
                </div>

                <div class="first">案例：回测报告数据计算公式详解</div>
                <div class="first">1、回测报告基础公式</div>

                <div class="img_center">
                  <table
                    border="0"
                    cellpadding="6"
                    cellspacing="1"
                    bgcolor="#999999"
                    class="gongshiTable"
                  >
                    <tbody>
                      <tr>
                        <td style="width: 200px">测试天数</td>
                        <td>从回测数据开始到结束的自然日</td>
                      </tr>
                      <tr>
                        <td>测试周期数</td>
                        <td>从回测数据开始到结束的K线根数</td>
                      </tr>
                      <tr>
                        <td>信号个数</td>
                        <td>信号出现的总个数</td>
                      </tr>
                      <tr>
                        <td>执行信号个数</td>
                        <td>信号执行的总个数</td>
                      </tr>
                      <tr>
                        <td>信号消失次数</td>
                        <td>信号消失的总次数</td>
                      </tr>
                      <tr>
                        <td>初始资金</td>
                        <td>初始化的资金</td>
                      </tr>
                      <tr>
                        <td>初始资金使用率</td>
                        <td>
                          手数*每手保证金率*第一个信号的开仓价*交易单位/初始资金
                        </td>
                      </tr>
                      <tr>
                        <td>最大资金使用率</td>
                        <td>在持仓周期内(开仓保证金/当前权益)的最大值</td>
                      </tr>
                      <tr>
                        <td>平均资金使用率</td>
                        <td>((开仓保证金/当前权益）求和)/持仓周期数</td>
                      </tr>
                      <tr>
                        <td>杠杆倍数</td>
                        <td>杠杆倍数 = 最大资金使用率 / 保证金率</td>
                      </tr>
                      <tr>
                        <td>回测期间最大权益</td>
                        <td>
                          回测期间最大的权益<br />整个测试过程中每个周期已缴保证金+剩余可用资金+持仓浮盈所得结果中的最大值
                        </td>
                      </tr>
                      <tr>
                        <td>回测期间最小权益</td>
                        <td>
                          回测期间最小的权益<br />整个测试过程中每个周期已缴保证金+剩余可用资金+持仓浮盈所得结果中的最小值
                        </td>
                      </tr>
                      <tr>
                        <td>最终权益</td>
                        <td>包括当前的可用资金和浮动盈亏</td>
                      </tr>
                      <tr>
                        <td>收益</td>
                        <td>总盈利-总亏损（已扣除手续费）</td>
                      </tr>
                      <tr>
                        <td>收益率</td>
                        <td>收益/初始资金</td>
                      </tr>
                      <tr>
                        <td>年化单利收益率</td>
                        <td>收益率/（测试天数/365）</td>
                      </tr>
                      <tr>
                        <td>月化单利收益率</td>
                        <td>收益率/（测试天数/30）</td>
                      </tr>
                      <tr>
                        <td>年化复利收益率</td>
                        <td>(最终权益/初始资金)^（365/测试天数）-1</td>
                      </tr>
                      <tr>
                        <td>月化复利收益率</td>
                        <td>(最终权益/初始资金)^(30/测试天数)-1</td>
                      </tr>
                      <tr>
                        <td>平均保证金收益率</td>
                        <td>
                          (单次交易收益/开仓保证金)求和/交易次数<br />=(Σ((每次交易盈利数值-手续费)/保证金))/交易次数
                        </td>
                      </tr>
                      <tr>
                        <td>扣除最大盈利后收益率</td>
                        <td>（最终权益-最大盈利-初始资金）/初始资金</td>
                      </tr>
                      <tr>
                        <td>扣除最大亏损后收益率</td>
                        <td>（最终权益+最大亏损-初始资金）/初始资金</td>
                      </tr>
                      <tr>
                        <td>夏普比率</td>
                        <td>
                          （年化单利收益率-无风险利率）/收益率的标准离差率<br />
                          计算公式：夏普比率=[E(Rp)－Rf]/σp；<br />
                          其中：<br />
                          E(Rp)：年化单利收益率<br />
                          Rf：无风险利率（大约是1.5%）<br />
                          σp：收益率的标准差率（年化标准差率）＝标准差率/sqrt
                          (测试天数/365)<br />
                          标准差率＝标准离差/初始资金
                        </td>
                      </tr>
                      <tr>
                        <td>索提诺比率</td>
                        <td>
                          （年化单利收益率-无风险利率）/下行收益率标准差<br />
                          其中：<br />
                          年化单利收益率=收益率/（测试天数/365）<br />
                          无风险利率=1.5%<br />
                          下行收益率标准差=下行标准差率/sqrt（测试天数/365）<br />
                          下行标准差率=下行标准离差/初始资金<br />
                          下行标准离差=<img
                            src="./imageswh9/stn1.png"
                            style="vertical-align: middle"
                          /><br />
                          n=交易次数<br />
                          r=每次收益<br />
                          <img
                            src="./imageswh9/stn2.png"
                            style="vertical-align: middle"
                          />=平均收益<br />
                          if r&lt;<img
                            src="./imageswh9/stn2.png"
                            style="vertical-align: middle"
                          />，f(t)=1<br />
                          if r&gt;=<img
                            src="./imageswh9/stn2.png"
                            style="vertical-align: middle"
                          />，f(t)=0
                        </td>
                      </tr>
                      <!-- <tr>
										<td><span class="normal">标准离差</span></td>
										<td>盈亏的标准离差=√(SUM((每次盈亏-平均盈亏)^2,N)/ N)</td>
									</tr>
									<tr>
										<td><span class="normal">标准离差率</span></td>
										<td>盈亏的标准离差率=标准离差/平均盈亏</td>
									</tr> -->
                      <tr>
                        <td>权益离散度</td>
                        <td>权益离散度=单次盈亏的平方和/交易次数，再开方</td>
                      </tr>
                      <tr>
                        <td>权益离散系数</td>
                        <td>权益离散系数=权益离散度/初始资金*100%</td>
                      </tr>
                      <tr>
                        <td>权益最大回撤</td>
                        <td>
                          从回测开始到结束，动态权益计算出来的波段从高点到低点回撤的最大值
                        </td>
                      </tr>
                      <tr>
                        <td>权益最大回撤时间</td>
                        <td>权益最大回撤出现的时间</td>
                      </tr>
                      <tr>
                        <td>权益最大回撤比率</td>
                        <td>（权益回撤/权益回撤时的权益）的最大值</td>
                      </tr>
                      <tr>
                        <td>权益最大回撤比率时间</td>
                        <td>权益最大回撤比率出现的时间</td>
                      </tr>
                      <tr>
                        <td>权益最长未创新高周期数</td>
                        <td>权益最长未创新高周期数</td>
                      </tr>
                      <tr>
                        <td>权益最长未创新高时间段</td>
                        <td>权益最长未创新高时间段</td>
                      </tr>
                      <tr>
                        <td>损益最大回撤</td>
                        <td>
                          从回测开始到结束，动态损益计算出来的波段从高点到低点回撤的最大值（损益最大回撤是以持仓等于0时的资金为标准计算的）
                        </td>
                      </tr>
                      <tr>
                        <td>损益最大回撤时间</td>
                        <td>损益最大回撤出现的时间</td>
                      </tr>
                      <tr>
                        <td>损益最大回撤比率</td>
                        <td>(损益回撤/损益回撤时的权益)的最大值</td>
                      </tr>
                      <tr>
                        <td>损益最大回撤比率时间</td>
                        <td>损益最大回撤比率出现的时间</td>
                      </tr>
                      <tr>
                        <td>损益最长未创新高周期数</td>
                        <td>损益最长未创新高周期数</td>
                      </tr>
                      <tr>
                        <td>损益最长未创新高时间段</td>
                        <td>损益最长未创新高时间段</td>
                      </tr>
                      <tr>
                        <td>本金风险率</td>
                        <td>（初始资金 - 回测期间最小权益）/初始资金</td>
                      </tr>
                      <tr>
                        <td>年化收益风险比率</td>
                        <td>年化单利收益率/本金风险率</td>
                      </tr>
                      <tr>
                        <td>胜率</td>
                        <td>（盈利次数+持平次数）/交易次数</td>
                      </tr>
                      <tr>
                        <td>*盈亏比率</td>
                        <td>
                          盈利交易的平均每次盈利/亏损交易的平均每次亏损<br />
                          平均每次盈利 = 总盈利/盈利交易次数<br />
                          平均每次亏损 = 总亏损/亏损交易次数
                        </td>
                      </tr>
                      <tr>
                        <td>*平均每次盈利</td>
                        <td>
                          平均每次盈利交易的盈利=总盈利/总盈利次数（计算手续费）
                        </td>
                      </tr>
                      <tr>
                        <td>*平均每次亏损</td>
                        <td>
                          平均每次亏损交易的亏损=总亏损/总亏损次数（计算手续费）
                        </td>
                      </tr>
                      <tr>
                        <td>*平均每次盈利/权益最大回撤</td>
                        <td>平均每次盈利/权益最大回撤</td>
                      </tr>
                      <tr>
                        <td>*平均每次盈利率/平均每次亏损率</td>
                        <td>
                          平均每次盈利率/平均每次亏损率<br />
                          平均每次盈利率 = SUM（单次盈利率) /
                          计算单次盈利率次数<br />
                          平均每次亏损率 = SUM（单次亏损率）/
                          计算单次亏损率次数<br />
                          单次盈利率 =
                          上一次持仓为0到今次持仓为0期间的盈利占初始资金的百分比
                          （盈利/初始资金）<br />
                          单次亏损率 =
                          上一次持仓为0到今次持仓为0期间的亏损占初始资金的百分比
                          （亏损/初始资金）
                        </td>
                      </tr>
                      <tr>
                        <td>*平均每次收益/平均每次亏损</td>
                        <td>平均每次收益/平均每次亏损</td>
                      </tr>
                      <tr>
                        <td>平均每次收益</td>
                        <td>
                          平均每笔交易的收益=（总盈利-总亏损）/
                          交易笔数（总成交量的 1/2）
                        </td>
                      </tr>
                      <tr>
                        <td>最大每手盈利</td>
                        <td>
                          每手盈利的最大值（每手盈利：对于每次交易，用该次交易的盈利值除以这次交易过程中的成交手数）
                        </td>
                      </tr>
                      <tr>
                        <td>最大每手亏损</td>
                        <td>
                          每手亏损的最大值（每手亏损：对于每次交易，用该次交易的亏损值除以这次交易过程中的成交手数）
                        </td>
                      </tr>
                      <tr>
                        <td>平均每手每次收益</td>
                        <td>平均每手每次交易的收益</td>
                      </tr>
                      <tr>
                        <td>总盈利/总亏损</td>
                        <td>总盈利/总亏损</td>
                      </tr>
                      <tr>
                        <td>总盈利</td>
                        <td>盈利的总和</td>
                      </tr>
                      <tr>
                        <td>总亏损</td>
                        <td>亏损的总和</td>
                      </tr>
                      <tr>
                        <td>*单次最大盈利</td>
                        <td>单次交易盈利的最大值</td>
                      </tr>
                      <tr>
                        <td>*单次最大亏损</td>
                        <td>单次交易亏损的最大值</td>
                      </tr>
                      <tr>
                        <td>单次最大盈利占比率</td>
                        <td>单次最大盈利/总盈利</td>
                      </tr>
                      <tr>
                        <td>单次最大亏损占比率</td>
                        <td>单次最大亏损/总亏损</td>
                      </tr>
                      <tr>
                        <td>收益/单次最大盈利</td>
                        <td>收益/单次最大盈利</td>
                      </tr>
                      <tr>
                        <td>收益/单次最大亏损</td>
                        <td>收益/单次最大亏损</td>
                      </tr>
                      <tr>
                        <td>*交易次数</td>
                        <td>发生交易的次数</td>
                      </tr>
                      <tr>
                        <td>*盈利次数</td>
                        <td>盈利的交易次数</td>
                      </tr>
                      <tr>
                        <td>*亏损次数</td>
                        <td>亏损的交易次数</td>
                      </tr>
                      <tr>
                        <td>*持平次数</td>
                        <td>持平的交易次数</td>
                      </tr>
                      <tr>
                        <td>*最大持续盈利次数</td>
                        <td>最大持续盈利的次数</td>
                      </tr>
                      <tr>
                        <td>*最大持续盈利次数出现时间</td>
                        <td>最大持续盈利的次数出现的时间</td>
                      </tr>
                      <tr>
                        <td>*最大持续亏损次数</td>
                        <td>最大持续亏损的次数</td>
                      </tr>
                      <tr>
                        <td>*最大持续亏损次数出现时间</td>
                        <td>最大持续亏损的次数出现的时间</td>
                      </tr>
                      <tr>
                        <td>空仓周期数</td>
                        <td>空仓的周期数</td>
                      </tr>
                      <tr>
                        <td>最长连续空仓周期数</td>
                        <td>最长连续空仓的周期数</td>
                      </tr>
                      <tr>
                        <td>*最长持仓周期数</td>
                        <td>持仓最长周期数</td>
                      </tr>
                      <tr>
                        <td>平均持仓周期数</td>
                        <td>平均多少根K线发生一笔交易=测试周期数/交易次数</td>
                      </tr>
                      <tr>
                        <td>*平均盈利持仓周期数</td>
                        <td>
                          平均多少根K线发生一笔盈利的交易=测试周期数/盈利次数
                        </td>
                      </tr>
                      <tr>
                        <td>*平均亏损持仓周期数</td>
                        <td>
                          平均多少根K线发生一笔亏损的交易=测试周期数/亏损次数
                        </td>
                      </tr>
                      <tr>
                        <td>平均持仓手数</td>
                        <td>每根K线的总持仓的累加 / 持仓周期数</td>
                      </tr>
                      <tr>
                        <td>最大持仓手数</td>
                        <td>在持仓周期内持仓手数最大值</td>
                      </tr>
                      <tr>
                        <td>平均资金使用金额</td>
                        <td>开仓保证金求和/持仓周期数</td>
                      </tr>
                      <tr>
                        <td>最大资金使用金额</td>
                        <td>在持仓周期内，开仓保证金额最大值</td>
                      </tr>
                      <tr>
                        <td>最大资金使用金额时间</td>
                        <td>在持仓周期内，最大资金使用金额的时间点</td>
                      </tr>
                      <tr>
                        <td>手续费</td>
                        <td>手续费合计</td>
                      </tr>
                      <tr>
                        <td>手续费/收益</td>
                        <td>手续费合计/收益</td>
                      </tr>
                      <tr>
                        <td>滑点损耗</td>
                        <td>滑点损耗合计</td>
                      </tr>
                      <tr>
                        <td>滑点损耗/收益</td>
                        <td>滑点损耗合计/收益</td>
                      </tr>
                      <tr>
                        <td>成交额</td>
                        <td>
                          成交额合计<br />成交额=成交价*（开仓或者平仓手数）*交易单位
                        </td>
                      </tr>
                      <tr>
                        <td>模型得分</td>
                        <td>
                          根据盈利能力、稳定性、风险暴露、敏感度计算的综合得分
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="paragraph">
                  注：对于盈利、亏损的计算，带有*的是都是以从开仓到持仓为0算一次交易计算盈亏，未标注*的是按照一开一平来计算盈亏。
                </div>
                <br />
                <div class="first">2、分项统计数据计算公式</div>
                <br />
                <div class="expand_box">
                  <div class="expand">
                    收益/风险：
                    <div
                      :class="['extendBtn', this.show[0] ? 'active' : '']"
                      @click="showImg(0)"
                    >
                      点击{{ this.show[0] ? "收起" : "展开" }}
                    </div>
                  </div>
                  <div class="paragraph">
                    （1）损益曲线图：策略的累计盈亏曲线，反映一段时间内平仓盈亏累加值的波动，每完整的交易一次计算一次损益值
                  </div>
                  <div class="img_center" v-if="this.show[0]">
                    <img src="./imageswh9/tb1-1.gif" />
                  </div>
                  <div class="paragraph">
                    （2）权益曲线图：反映某一个时点的权益波动情况，每根K线都动态的统计一次权益数值
                  </div>
                  <div class="img_center" v-if="this.show[0]">
                    <img src="./imageswh9/tb1-2.gif" />
                  </div>
                  <div class="paragraph">
                    （3）损盈分布图：根据距离平均盈亏的离散程度分析交易的整体盈利情况
                  </div>
                  <div class="img_center" v-if="this.show[0]">
                    <img src="./imageswh9/tb1-3.gif" />
                  </div>
                  <div class="paragraph">
                    （4）损盈直方图：统计落入盈亏净值区间内的次数，对比盈利和亏损能力
                  </div>
                  <div class="img_center" v-if="this.show[0]">
                    <img src="./imageswh9/tb1-4.gif" />
                  </div>
                  <div class="paragraph">
                    （5）权益回撤直方图：统计落入某一回撤区间的次数，反映权益回撤的金额分布
                  </div>
                  <div class="img_center" v-if="this.show[0]">
                    <img src="./imageswh9/tb1-5.gif" />
                  </div>
                  <div class="paragraph">
                    （6）连续亏损次数：统计连续亏损的次数，投资者可结合自身对风险的承受能力综合考量策略的稳定性
                  </div>
                  <div class="img_center" v-if="this.show[0]">
                    <img src="./imageswh9/tb1-6.gif" />
                  </div>
                </div>
                <br />
                <div class="expand_box">
                  <div class="expand">
                    浮动盈亏：
                    <div
                      :class="['extendBtn', this.show[1] ? 'active' : '']"
                      @click="showImg(1)"
                    >
                      点击{{ this.show[1] ? "收起" : "展开" }}
                    </div>
                  </div>
                  <div class="paragraph">
                    （1）权益面积图：对比权益的高点位置和权益波动，直观的查看权益回撤的幅度
                  </div>
                  <div class="img_center" v-if="this.show[1]">
                    <img src="./imageswh9/tb2-1.gif" />
                  </div>
                  <div class="paragraph">
                    （2）浮盈面积图：对比权益面积图，分析浮盈波动情况
                  </div>
                  <div class="img_center" v-if="this.show[1]">
                    <img src="./imageswh9/tb2-2.gif" />
                  </div>
                  <div class="paragraph">
                    （3）浮亏面积图：对比权益面积图，分析浮亏波动变化
                  </div>
                  <div class="img_center" v-if="this.show[1]">
                    <img src="./imageswh9/tb2-3.gif" />
                  </div>
                  <div class="paragraph">
                    （4）浮盈分布图：根据距离平均浮盈的离散程度分析交易的浮盈极值和整体盈利状态
                  </div>
                  <div class="img_center" v-if="this.show[1]">
                    <img src="./imageswh9/tb2-4.gif" />
                  </div>
                  <div class="paragraph">
                    （5）浮亏分布图：根据距离平均浮动亏损值的离散程度分析浮亏的极值和整体亏损情况
                  </div>
                  <div class="img_center" v-if="this.show[1]">
                    <img src="./imageswh9/tb2-5.gif" />
                  </div>
                  <div class="paragraph">
                    （6）浮盈直方图：统计落在指定浮盈区间内的交易次数，分析策略的盈利能力
                  </div>
                  <div class="img_center" v-if="this.show[1]">
                    <img src="./imageswh9/tb2-6.gif" />
                  </div>
                  <div class="paragraph">
                    （7）浮亏直方图：统计落在固定浮亏区间内的交易次数，分析策略的亏损程度
                  </div>
                  <div class="img_center" v-if="this.show[1]">
                    <img src="./imageswh9/tb2-7.gif" />
                  </div>
                </div>
                <br />
                <div class="expand_box">
                  <div class="expand">
                    阶段分析：
                    <div
                      :class="['extendBtn', this.show[2] ? 'active' : '']"
                      @click="showImg(2)"
                    >
                      点击{{ this.show[2] ? "收起" : "展开" }}
                    </div>
                  </div>
                  <div class="paragraph">
                    （1）月度统计：统计当月交易的盈亏和成本大小
                  </div>
                  <div class="img_center" v-if="this.show[2]">
                    <img src="./imageswh9/tb3-1.gif" />
                  </div>
                  <div class="paragraph">
                    （2）日统计：统计当日的交易的盈亏和成本大小
                  </div>
                  <div class="img_center" v-if="this.show[2]">
                    <img src="./imageswh9/tb3-2.gif" />
                  </div>
                </div>
                <br />
                <div class="expand_box">
                  <div class="expand">
                    效率分析：
                    <div
                      :class="['extendBtn', this.show[3] ? 'active' : '']"
                      @click="showImg(3)"
                    >
                      点击{{ this.show[3] ? "收起" : "展开" }}
                    </div>
                  </div>
                  <div class="paragraph">
                    （1）总效率分布图：以做多为例，买在最低点卖在最高点视效率为100%，按交易价格折算每次交易的效率
                  </div>
                  <div class="img_center" v-if="this.show[3]">
                    <img src="./imageswh9/tb4-1.gif" />
                  </div>
                  <div class="paragraph">
                    （2）建仓效率分布图：以做多为例，买在最低点即为最佳入场点，效率为100%，再按实际入场点折算每次建仓的效率
                  </div>
                  <div class="img_center" v-if="this.show[3]">
                    <img src="./imageswh9/tb4-2.gif" />
                  </div>
                  <div class="paragraph">
                    （3）平仓效率分布图：以做多为例，卖在最高点即为最佳出场点，效率为100%，再按实际出场点折算每次平仓的效率
                  </div>
                  <div class="img_center" v-if="this.show[3]">
                    <img src="./imageswh9/tb4-3.gif" />
                  </div>
                </div>
                <br />
                <div class="expand_box">
                  <div class="expand">
                    损盈分析：
                    <div
                      :class="['extendBtn', this.show[4] ? 'active' : '']"
                      @click="showImg(4)"
                    >
                      点击{{ this.show[4] ? "收起" : "展开" }}
                    </div>
                  </div>
                  <div class="paragraph">
                    （1）胜率分析：统计不同盈利百分比下的胜率分布
                  </div>
                  <div class="img_center" v-if="this.show[4]">
                    <img src="./imageswh9/tb5-1.gif" />
                  </div>
                  <div class="paragraph">
                    （2）盈利分析：统计一定盈利范围内的盈利次数
                  </div>
                  <div class="img_center" v-if="this.show[4]">
                    <img src="./imageswh9/tb5-2.gif" />
                  </div>
                  <div class="paragraph">
                    （3）亏损分析：统计一定亏损范围内的亏损次数
                  </div>
                  <div class="img_center" v-if="this.show[4]">
                    <img src="./imageswh9/tb5-3.gif" />
                  </div>
                  <div class="paragraph">
                    （4）回撤分析：按回撤比例分析权益回撤幅度
                  </div>
                  <div class="img_center" v-if="this.show[4]">
                    <img src="./imageswh9/tb5-4.gif" />
                  </div>
                </div>
              </div>

              <div v-if="id == 1 && tabId == 0">
               <div class="paragraph">
                  可视化的盘口算法模型回测平台，能够同时展示tick数据变化、持仓信息、挂单详情、以及权益曲线变化过程，并提供360度视角的多维度回测报告。
                </div>
                <div class="case_box">
                  <div class="first">案例：盘口模型回测过程详解</div>
                  <div class="paragraph">
                    第一步：点击左侧【回测】标签，双击要回测的订单流模型，可进入订单流模型回测界面，可点击鼠标右键，切换回测日期，并设置回测速度倍数。
                  </div>

                  <div class="img_center">
                    <img src="./imageswh9/img2.jpg" />
                  </div>

                  <div class="paragraph">
                    第二步：系统开始进行回测计算，可视化的回测界面，包含了Tick图形变化，持仓列表、挂单列表以及权益曲线。
                  </div>

                  <div class="img_center">
                    <img src="./imageswh9/imga.png" />
                  </div>

                  <div class="first">Tick图画线机制：</div>
                  <div class="paragraph">红色实线：买开挂单价位；</div>
                  <div class="paragraph">绿色实线：卖开挂单价位；</div>
                  <div class="paragraph">红色虚线：买平挂单价位；</div>
                  <div class="paragraph">绿色虚线：卖平挂单价位。</div>
                  <br />
                  <div class="paragraph">
                    第三步：可点击鼠标右键，选择查看模型回测报告、回测交易明细、回测运行日志。
                  </div>

                  <div class="img_center">
                    <img src="./imageswh9/img3.png" />
                  </div>
                </div>
              </div>

              <div v-if="id == 1 && tabId == 1">
                
                <div class="paragraph">
                  <common-data name="appShortName_17"/>的仿真撮合机制，既考虑到了委托价等于对手价时，对手盘挂单量不足，部分成交的情况，同时，当委托价等于排队价时，还会计算挂单成交比例，按比例撮合成交，完美虚拟真实交易过程。
                </div>
                <div class="case_box">
                  <div class="first">案例：仿真撮合机制计算公式详解</div>
                  <div class="paragraph">
                    订单流模型回测采用交易所的行情数据作为撮合基础，模型回测报告、回测交易明细均使用如下算法统计交易结果和相关数据。
                  </div>
                  <br />
                  <div class="first">仿真撮合机制：</div>
                  <div class="paragraph">以买入委托为例来说明：
                  </div>
                  <div class="paragraph">
                    收到委托之后先使用最新一笔TICK主动撮合一次，如果没有全成等下一笔TICK进行撮合。
                  </div>
                  <div class="paragraph">1、委托价 > 卖一，成交价 = 委托价、卖一价、最新价的三者中间价；</div>
                  <div class="paragraph">
                    2、委托价 = 卖一，成交价 = 卖一价；
                  </div>
                  <div class="paragraph">
                    3、委托价 >= 买一 并且 委托价 &lt;卖一 并且 最新价 = 买一，成交价 = 买一价;
                  </div>
                  <div class="paragraph">
                    4、成交手数 = 该笔TICK的成交手数、委托手数二者的最小值。
                  </div>
                </div>
              </div>

              <div v-if="id == 2 && tabId == 0">
                
                <div class="paragraph">
                  <common-data name="appShortName_17"/>支持模组单元调用算法交易组件，使用算法交易策略控制交易过程，根据盘口情况智能拆单，不仅支持主动、被动型算法策略，还支持更加高效的综合型算法交易策略。能够提高交易效率，降低冲击成本，还能隐匿机构交易行为，防止下单对趋势产生影响。
                </div>
                <div class="case_box">
                  <div class="first">案例：根据盘口挂单自动分批策略</div>
                  <div class="first">1、算法交易接管模组信号实现方式</div>
                  <div class="paragraph">
                    模型加载到模组运行时，可选择算法下单组件，系统提供了常用的几种模型信号处理组件，也支持编写自定义算法组件。
                  </div>
                  <br />
                  <div class="first">组件一号：</div>
                  <div style="font-size: 14px">
                    （1）委托方式：开仓对价，平仓市价。
                  </div>
                  <div style="font-size: 14px">
                    （2）平仓信号：先撤未成交开仓挂单，按实际持仓手数平仓。
                  </div>
                  <div style="font-size: 14px">
                    （3）反手信号：平仓成交后发开仓委托。
                  </div>
                  <br />
                  <div class="first">组件二号：</div>
                  <div style="font-size: 14px">
                    （1）委托方式：开仓排队价，平仓对价且市价追价。
                  </div>
                  <div style="font-size: 14px">
                    （2）平仓信号：先撤未成交开仓挂单，按实际持仓手数平仓。
                  </div>
                  <div style="font-size: 14px">
                    （3）反手信号：平仓成交后发开仓委托。
                  </div>
                  <br />
                  <div class="first">组件三号：</div>
                  <div style="font-size: 14px">
                    （1）委托方式：开仓对价，平仓对价。
                  </div>
                  <div style="font-size: 14px">
                    （2）平仓信号：先撤未成交开仓挂单，按实际手数平仓。
                  </div>
                  <div style="font-size: 14px">
                    （3）反手信号：平仓成交后发开仓委托。
                  </div>
                  <div style="font-size: 14px">
                    （4）智能分批：根据盘口挂单智能分批下单。
                  </div>

                  <div class="img_center">
                    <img src="./imageswh9/img4.jpg" />
                  </div>

                  <div class="first">2、智能分批算法组件的基本逻辑</div>
                  <div class="paragraph">
                    可先使用F_FreshSig函数刷新信号，然后使用IF语句根据信号种类添加不同的处理机制，系统支持使用For循环遍历委托，支持数组，记录成交手数，并按照指定价格和手数发送委托。
                  </div>
                  <br />
                  <div
                    class="title expand"
                    style="width: auto; justify-content: left"
                  >
                    根据盘口挂单智能分批部分核心源码：
                    <div class="extendCodeBtn" @click="dropdowncode(0)">点击展开源码</div>
                  </div>
                  <pre
                  v-show="showcode[0]"
                    style="
                      white-space: revert;
                      text-indent: 0;
                      margin-top: 8px;
                    "
                  >
//---------------------买开委托处理--------------------//
//反手委托：平仓成交后发开仓委托
For X = 0 To BKDN - 1 //遍历买开处理
{
	If(BKDFLG[X] > 0) //如果已开启买开处理
	{
		//------------------------买开委托发出------------------------//
		//根据盘口挂单智能分批下单
		If(1)
		{
			If(BKOFLG[X] == 0) //如果没有买开委托
			{
				If(BKVLM[X] > 0) //如果买开手数大于0
				{
					BKM[BKN] = Min(Ceiling(P * ASKV,1),BKVLM[X]); //买开委托手数
					BKVLM[X] = BKVLM[X] - BKM[BKN]; //买开手数
					BKSM[BKN] = BKM[BKN]; //买开总手数
					BKP[BKN] = BKPRC[X]; //买开委托价格
					If(BKDFLG[X] == 1) //如果是BK信号买开
					{
						Commentary("【买开：买开委托" + Text(BKN + 1) + "发出】");
					}
					Else If(BKDFLG[X] == 2) //如果是BPK信号买开
					{
						Commentary("【买平开：买开委托" + Text(BKN + 1) + "发出】");
					}
					Else If(BKDFLG[X] == 3) //如果是SP信号买开
					{
						Commentary("【卖平：买开委托" + Text(BKN + 1) + "发出】");
					}
					Commentary("【盘口数据：卖一价=" + Text(ASKP) + "，卖一量=" + Text(ASKV) + "】");
					Commentary("【盘口数据：买一价=" + Text(BIDP) + "，买一量=" + Text(BIDV) + "】");
					Commentary("【买开委托：买开价格=" + Text(BKP[BKN]) + "，买开手数=" + Text(BKM[BKN]) + "】");
					BKID[BKN] = COD.A_SendOrder(Enum_Buy,Enum_Entry,BKM[BKN],BKP[BKN]); //发出买开委托
					BKT[BKN] = NOW; //买开委托时间
					BKDX[BKN] = X; //买开委托序号
					BKFLG[BKN] = BKDFLG[X]; //已发出买开委托
					BKN = BKN + 1; //买开委托数量
					BKOFLG[X] = 1; //已发出买开委托
				}
				Else If(BKVLM[X] == 0) //如果买开手数等于0
				{
					BKDFLG[X] = 0; //买开处理标志归0
				}
			}
		}
	}
}
						</pre
                  >
                  <br />
                  <div class="first">
                    3、是否需要编写多个信号处理组件绑定多个模型
                  </div>
                  <div class="paragraph">
                    具有相同信号处理方式和算法拆单需求的多个模型，可以绑定同一个信号处理组件。每个模型单元独立运行，互不影响。
                  </div>
                </div>
              </div>
              <div v-if="id == 2 && tabId == 1">
              
                <div class="paragraph">
                  使用算法交易策略替代手动下单控制交易过程。通过对持仓信息、挂单信息，成交回报，委托回报等信息的监控，实现了对交易过程的精细化控制。成交效率高，对市场变化反应迅速，降低冲击成本。
                </div>
                <div class="case_box">
                  <div class="first">案例1：手动下单+智能分批算法</div>
                  <div class="paragraph">
                    对于大资金客户，是否有下单单量大，唯恐惊扰行情趋势的困扰？是否有欲拉动行情却缕缕付出了大量成本的困扰？这里我们以此为例通过手动下单调用算法交易的方式介绍两个案例来解决你的困扰。
                  </div>
                  <br />
                  <div class="first">
                    策略1：通过算法根据买卖量，自动拆分大单
                  </div>
                  <br />
                  <div class="first">交易思路解析：</div>
                  <div class="paragraph">
                    1、取得手动下单的合约、手数、买卖方向、开平方向；自设委托价格。
                  </div>
                  <div class="paragraph">2、如果为开仓：</div>
                  <div class="paragraph">（1）如果为买入开仓：</div>
                  <div class="paragraph">
                    分批买入，取盘口卖一量*1/2与剩余下单手数比较，取数量较小值根据盘口卖一价买入，第一批成交后，再委托第二批，直至完全成交后退出算法。
                  </div>
                  <div class="paragraph">（2）如果为卖出开仓：</div>
                  <div class="paragraph">
                    分批卖出，取盘口买一量*1/2与剩余下单手数比较，取数量较小值根据盘口买一价卖出，第一批成交后，再委托第二批，直至完全成交后退出算法。
                  </div>
                  <div class="paragraph">3、如果为平仓：</div>
                  <div class="paragraph">（1）如果为买入平仓：</div>
                  <div class="paragraph">分批处理同买入开仓。</div>
                  <div class="paragraph">（2）如果为卖出平仓：</div>
                  <div class="paragraph">分批处理同卖出开仓。</div>
                  <br />
                  <div
                    class="title expand"
                    style="width: auto; justify-content: left"
                  >
                    源码实现：
                    <div class="extendCodeBtn" @click="dropdowncode(1)">点击展开源码</div>
                  </div>
                  <pre  v-show="showcode[1]">
	Vars
		Global_String AID; //账号
		Global_String COD; //合约编码
		Numeric SIG; //下单信号
		Numeric P; //数值比例
		Numeric SH; //上海合约标志
		Numeric BIDP,ASKP; //买卖一价
		Numeric BIDV,ASKV; //买卖一量
		Numeric BRP0,BRP1,BRP; //多头可用持仓
		Numeric SRP0,SRP1,SRP; //空头可用持仓
		Numeric OPFLG; //模型处理标志
		Global_Numeric VLM; //交易手数
		Global_Numeric KPFLG; //委托处理标志
		Global_Numeric BKDFLG; //买开处理标志
		Global_Numeric SKDFLG; //卖开处理标志
		Global_Numeric BPDFLG; //买平处理标志
		Global_Numeric SPDFLG; //卖平处理标志
		Global_Numeric BKID,SKID; //开仓委托
		Global_Numeric BKFLG,SKFLG; //开仓标志
		Global_Numeric BKM,SKM; //开仓委托手数
		Global_Numeric BKP,SKP; //开仓委托价格
		Global_Numeric BPID0,BPID1,BPID; //买平委托
		Global_Numeric SPID0,SPID1,SPID; //卖平委托
		Global_Numeric BPFLG0,BPFLG1,BPFLG; //买平标志
		Global_Numeric SPFLG0,SPFLG1,SPFLG; //卖平标志
		Global_Numeric BPM0,BPM1,BPM; //买平委托手数
		Global_Numeric SPM0,SPM1,SPM; //卖平委托手数
		Global_Numeric BPP0,BPP1,BPP; //买平委托价格
		Global_Numeric SPP0,SPP1,SPP; //卖平委托价格
	Begin
		//------------------获取手动下单信息-----------------//
		If(1)
		{
			If(KPFLG == 0) //如果未开启委托处理
			{
				AID = M_GetTradeAccount(0); //账号
				COD = M_GetTradeContract(); //合约编码
				SIG = M_GetTradeSig(); //下单信号
				VLM = M_GetTradeVol(); //交易手数
				If(VLM > 0 && COD.A_IsExchangeOpen() == 1) //如果交易手数大于0，且当前状态是开盘
				{
					If(SIG == Sig_BK) //如果是买开
					{
						Commentary("【" + COD + "买开：手动买开" + Text(VLM) + "手】");
						BKDFLG = 1; //开启买开处理
					}
					Else If(SIG == Sig_SP) //如果是卖平
					{
						Commentary("【" + COD + "卖平：手动卖平" + Text(VLM) + "手】");
						SPDFLG = 1; //开启卖平处理
					}
					Else If(SIG == Sig_SK) //如果是卖开
					{
						Commentary("【" + COD + "卖开：手动卖开" + Text(VLM) + "手】");
						SKDFLG = 1; //开启卖开处理
					}
					Else If(SIG == Sig_BP) //如果是买平
					{
						Commentary("【" + COD + "买平：手动买平" + Text(VLM) + "手】");
						BPDFLG = 1; //开启买平处理
					}
					KPFLG = 1; //开启委托处理
				}
			}
			If(KPFLG == 1 && COD.A_IsExchangeOpen() == 1) //如果已开启委托处理，且当前状态是开盘
			{
				OPFLG = 1; //开启模型处理
			}
		}
		//---------------------期货变量赋值---------------------//
		If(OPFLG == 1)
		{
			P = 0.5; //数值比例
			BIDP = COD.Price("Bid1"); //买一价
			ASKP = COD.Price("Ask1"); //卖一价
			BIDV = COD.Price("BidVol1"); //买一量
			ASKV = COD.Price("AskVol1"); //卖一量
			SH = COD.A_IsSHCode(); //上海合约标志
			BRP = COD.A_BuyRemainPosition(AID); //多头可用持仓
			SRP = COD.A_SellRemainPosition(AID); //空头可用持仓
			If(SH == 1) //如果是上期所合约
			{
				BRP0 = COD.A_TodayBuyRemainPosition(AID); //多头今仓可用持仓
				SRP0 = COD.A_TodaySellRemainPosition(AID); //空头今仓可用持仓
				BRP1 = BRP - BRP0; //多头老仓可用持仓
				SRP1 = SRP - SRP0; //空头老仓可用持仓
			}
		}
		//------------------查询组件当前任务-----------------//
		If(OPFLG == 1)
		{
			If(BKFLG == 1) //如果有买开委托
			{
				If(F_OrderStatus(BKID) == Enum_Filled) //如果买开委托成交
				{
					Commentary("【" + COD + "买开：买开委托成交】");
					VLM = VLM - BKM; //买开手数
					BKFLG = 0; //买开标志归0
				}
			}
			If(SH == 1) //如果是上期所合约
			{
				If(SPFLG0 == 1) //如果有卖平今仓委托
				{
					If(F_OrderStatus(SPID0) == Enum_Filled) //如果卖平今仓委托成交
					{
						Commentary("【" + COD + "卖平：卖平今仓委托成交】");
						VLM = VLM - SPM0; //卖平手数
						SPFLG0 = 0; //卖平今仓标志归0
					}
				}
				If(SPFLG1 == 1) //如果有卖平老仓委托
				{
					If(F_OrderStatus(SPID1) == Enum_Filled) //如果卖平老仓委托成交
					{
						Commentary("【" + COD + "卖平：卖平老仓委托成交】");
						VLM = VLM - SPM1; //卖平手数
						SPFLG1 = 0; //卖平老仓标志归0
					}
				}
			}
			Else //如果非上期所合约
			{
				If(SPFLG == 1) //如果有卖平委托
				{
					If(F_OrderStatus(SPID) == Enum_Filled) //如果卖平委托成交
					{
						Commentary("【" + COD + "卖平：卖平委托成交】");
						VLM = VLM - SPM; //卖平手数
						SPFLG = 0; //卖平标志归0
					}
				}
			}
			If(SKFLG == 1) //如果有卖开委托
			{
				If(F_OrderStatus(SKID) == Enum_Filled) //如果卖开委托成交
				{
					Commentary("【" + COD + "卖开：卖开委托成交】");
					VLM = VLM - SKM; //卖开手数
					SKFLG = 0; //卖开标志归0
				}
			}
			If(SH == 1) //如果是上期所合约
			{
				If(BPFLG0 == 1) //如果有买平今仓委托
				{
					If(F_OrderStatus(BPID0) == Enum_Filled) //如果买平今仓委托成交
					{
						Commentary("【" + COD + "买平：买平今仓委托成交】");
						VLM = VLM - BPM0; //买平手数
						BPFLG0 = 0; //买平今仓标志归0
					}
				}
				If(BPFLG1 == 1) //如果有买平老仓委托
				{
					If(F_OrderStatus(BPID1) == Enum_Filled) //如果买平老仓委托成交
					{
						Commentary("【" + COD + "买平：买平老仓委托成交】");
						VLM = VLM - BPM1; //买平手数
						BPFLG1 = 0; //买平老仓标志归0
					}
				}
			}
			Else //如果非上期所合约
			{
				If(BPFLG == 1) //如果有买平委托
				{
					If(F_OrderStatus(BPID) == Enum_Filled) //如果买平委托成交
					{
						Commentary("【" + COD + "买平：买平委托成交】");
						VLM = VLM - BPM; //买平手数
						BPFLG = 0; //买平标志归0
					}
				}
			}
		}
		//------------------------委托发出------------------------//
		If(OPFLG == 1)
		{
			//---------------------买开委托处理--------------------//
			If(BKDFLG == 1) //如果已开启买开处理
			{
				If(BKFLG == 0) //如果没有买开委托
				{
					//------------------------买开委托发出------------------------//
					If(1)
					{
						BKM = Min(Ceiling(P * ASKV,1),VLM); //买开委托手数
						If(BKM > 0) //如果买开委托手数大于0
						{
							BKP = ASKP; //买开委托价格
							Commentary("【" + COD + "买开：公式买开" + Text(BKM) + "手】");
							Commentary("【" + COD + "买开：买开委托发出】");
							BKID = COD.A_SendOrder(Enum_Buy,Enum_Entry,BKM,BKP,AID); //发出买开委托
							BKFLG = 1; //已发出买开委托
						}
						Else If(BKM == 0) //如果买开委托手数等于0
						{
							Commentary("【" + COD + "买开：买开委托完成】");
							Exit(); //退出公式
						}
					}
				}
			}
			//---------------------卖平委托处理--------------------//
			If(SPDFLG > 0) //如果已开启卖平处理
			{
				If(SPFLG0 == 0 && SPFLG1 == 0 && SPFLG == 0) //如果没有卖平委托
				{
					//------------------------卖平委托发出------------------------//
					If(1)
					{
						SPM = Min(Ceiling(P * BIDV,1),VLM); //卖平委托手数
						If(BRP > 0 && SPM > 0) //如果有多头可用持仓，且卖平委托手数大于0
						{
							If(SH == 1) //如果是上期所合约
							{
								If(BRP0 > 0) //如果有多头今仓可用持仓
								{
									SPM0 = Min(SPM,BRP0); //卖平今仓委托手数
									SPM1 = Min(SPM - SPM0,BRP1); //卖平老仓委托手数
									SPP0 = BIDP; //卖平今仓委托价格
									Commentary("【" + COD + "卖平：公式卖平今仓" + Text(SPM0) + "手】");
									Commentary("【" + COD + "卖平：卖平今仓委托发出】");
									SPID0 = COD.A_SendOrder(Enum_Sell,Enum_ExitToday,SPM0,SPP0,AID); //发出卖平今仓委托
									SPFLG0 = 1; //已发出卖平今仓委托
								}
								Else If(BRP0 == 0) //如果没有多头今仓可用持仓
								{
									SPM1 = Min(SPM,BRP1); //卖平老仓委托手数
								}
								If(BRP1 > 0 && SPM1 > 0) //如果有多头老仓可用持仓，且卖平老仓委托手数大于0
								{
									SPP1 = BIDP; //卖平老仓委托价格
									Commentary("【" + COD + "卖平：公式卖平老仓" + Text(SPM1) + "手】");
									Commentary("【" + COD + "卖平：卖平老仓委托发出】");
									SPID1 = COD.A_SendOrder(Enum_Sell,Enum_Exit,SPM1,SPP1,AID); //发出卖平老仓委托
									SPFLG1 = 1; //已发出卖平老仓委托
								}
							}
							Else //如果非上期所合约
							{
								SPM = Min(SPM,BRP); //卖平委托手数
								SPP = BIDP; //卖平委托价格
								Commentary("【" + COD + "卖平：公式卖平" + Text(SPM) + "手】");
								Commentary("【" + COD + "卖平：卖平委托发出】");
								SPID = COD.A_SendOrder(Enum_Sell,Enum_Exit,SPM,SPP,AID); //发出卖平委托
								SPFLG = 1; //已发出卖平委托
							}
						}
						Else If(BRP == 0 || SPM == 0) //如果没有多头可用持仓，或卖平委托手数等于0
						{
							Commentary("【" + COD + "卖平：卖平委托完成】");
							Exit(); //退出公式
						}
					}
				}
			}
			//---------------------卖开委托处理--------------------//
			If(SKDFLG == 1) //如果已开启卖开处理
			{
				If(SKFLG == 0) //如果没有卖开委托
				{
					//------------------------卖开委托发出------------------------//
					If(1)
					{
						SKM = Min(Ceiling(P * BIDV,1),VLM); //卖开委托手数
						If(SKM > 0) //如果卖开委托手数大于0
						{
							SKP = BIDP; //卖开委托价格
							Commentary("【" + COD + "卖开：公式卖开" + Text(SKM) + "手】");
							Commentary("【" + COD + "卖开：卖开委托发出】");
							SKID = COD.A_SendOrder(Enum_Sell,Enum_Entry,SKM,SKP,AID); //发出卖开委托
							SKFLG = 1; //已发出卖开委托
						}
						Else If(SKM == 0) //如果卖开委托手数等于0
						{
							Commentary("【" + COD + "卖开：卖开委托完成】");
							Exit(); //退出公式
						}
					}
				}
			}
			//---------------------买平委托处理--------------------//
			If(BPDFLG > 0) //如果已开启买平处理
			{
				If(BPFLG0 == 0 && BPFLG1 == 0 && BPFLG == 0) //如果没有买平委托
				{
					//------------------------买平委托发出------------------------//
					If(1)
					{
						BPM = Min(Ceiling(P * ASKV,1),VLM); //买平委托手数
						If(SRP > 0 && BPM > 0) //如果有空头可用持仓，且买平委托手数大于0
						{
							If(SH == 1) //如果是上期所合约
							{
								If(SRP0 > 0) //如果有空头今仓可用持仓
								{
									BPM0 = Min(BPM,SRP0); //买平今仓委托手数
									BPM1 = Min(BPM - BPM0,SRP1); //买平老仓委托手数
									BPP0 = ASKP; //买平今仓委托价格
									Commentary("【" + COD + "买平：公式买平今仓" + Text(BPM0) + "手】");
									Commentary("【" + COD + "买平：买平今仓委托发出】");
									BPID0 = COD.A_SendOrder(Enum_Buy,Enum_ExitToday,BPM0,BPP0,AID); //发出买平今仓委托
									BPFLG0 = 1; //已发出买平今仓委托
								}
								Else If(SRP0 == 0) //如果没有空头今仓可用持仓
								{
									BPM1 = Min(BPM,SRP1); //买平老仓委托手数
								}
								If(SRP1 > 0 && BPM1 > 0) //如果有空头老仓可用持仓，且买平老仓委托手数大于0
								{
									BPP1 = ASKP; //买平老仓委托价格
									Commentary("【" + COD + "买平：公式买平老仓" + Text(BPM1) + "手】");
									Commentary("【" + COD + "买平：买平老仓委托发出】");
									BPID1 = COD.A_SendOrder(Enum_Buy,Enum_Exit,BPM1,BPP1,AID); //发出买平老仓委托
									BPFLG1 = 1; //已发出买平老仓委托
								}
							}
							Else //如果非上期所合约
							{
								BPM = Min(BPM,SRP); //买平委托手数
								BPP = ASKP; //买平委托价格
								Commentary("【" + COD + "买平：公式买平" + Text(BPM) + "手】");
								Commentary("【" + COD + "买平：买平委托发出】");
								BPID = COD.A_SendOrder(Enum_Buy,Enum_Exit,BPM,BPP,AID); //发出买平委托
								BPFLG = 1; //已发出买平委托
							}
						}
						Else If(SRP == 0 || BPM == 0) //如果没有空头可用持仓，或买平委托手数等于0
						{
							Commentary("【" + COD + "买平：买平委托完成】");
							Exit(); //退出公式
						}
					}
				}
			}
		}
	End
						</pre
                  >
                  <br />
                  <div class="paragraph">
                    通过右上方菜单【量化】->【算法交易运行池】->【算法交易下单】，调出算法交易下单界面，按下图所示方法实现手动下单调用算法交易：
                  </div>

                  <div class="img_center click_bigimg">
                    <img src="./imageswh9/jiaoyi1.jpg" />
                  </div>

                  <div class="paragraph">注：</div>
                  <div class="paragraph">
                    ①如果再次下单，会再次加载该模型，不会直接在前一个算法交易模型中继续执行。
                  </div>
                  <div class="paragraph">
                    ②如果模型中含有函数Exit()，则模型执行完毕后会自动退出。
                  </div>
                  <br />
                  <div class="first">
                    策略2：拉动行情，每次自动把买盘吃光，将行情往上拉，反之亦然
                  </div>
                  <br />
                  <div class="first">交易思路解析：</div>
                  <div class="paragraph">
                    1、取值手动下单的合约、手数、买卖方向、开平方向；自设委托价格。
                  </div>
                  <div class="paragraph">2、如果为开仓：</div>
                  <div class="paragraph">（1）如果为买入开仓：</div>
                  <div class="paragraph">
                    分批买入，取盘口卖一量与剩余下单手数比较，取数量较小值根据盘口卖一价买入。
                  </div>
                  <div class="paragraph">
                    如果盘口卖一价变化，撤单并重新委托，取盘口卖一量与该批剩余下单手数比较，取数量较小值根据盘口卖一价买入，直至完全成交完全成交后退出算法。
                  </div>
                  <div class="paragraph">（2）如果为卖出开仓：</div>
                  <div class="paragraph">
                    分批卖出，取盘口买一量与剩余下单手数比较，取数量较小值根据盘口买一价卖出。
                  </div>
                  <div class="paragraph">
                    如果盘口买一价变化，撤单并重新委托，取盘口买一量与该批剩余下单手数比较，取数量较小值根据盘口买一价卖出，直至完全成交完全成交后退出算法。
                  </div>
                  <div class="paragraph">3、如果为平仓：</div>
                  <div class="paragraph">（1）如果为买入平仓：</div>
                  <div class="paragraph">分批处理同买入开仓。</div>
                  <div class="paragraph">（2）如果为卖出开仓：</div>
                  <div class="paragraph">分批处理同卖出开仓。</div>
                  <br />
                  <div
                    class="title expand"
                    style="width: auto; justify-content: left"
                  >
                    源码实现：
                    <div class="extendCodeBtn" @click="dropdowncode(2)">点击展开源码</div>
                  </div>
                  <pre v-show="showcode[2]">
	Vars
		Global_String AID; //账号
		Global_String COD; //合约编码
		Numeric SIG; //下单信号
		Numeric SH; //上海合约标志
		Numeric BIDP,ASKP; //买卖一价
		Numeric BIDV,ASKV; //买卖一量
		Numeric BRP0,BRP1,BRP; //多头可用持仓
		Numeric SRP0,SRP1,SRP; //空头可用持仓
		Numeric OPFLG; //模型处理标志
		Global_Numeric VLM; //交易手数
		Global_Numeric KPFLG; //委托处理标志
		Global_Numeric BKDFLG; //买开处理标志
		Global_Numeric SKDFLG; //卖开处理标志
		Global_Numeric BPDFLG; //买平处理标志
		Global_Numeric SPDFLG; //卖平处理标志
		Global_Numeric BKID,SKID; //开仓委托
		Global_Numeric BKFLG,SKFLG; //开仓标志
		Global_Numeric BKDEL,SKDEL; //开仓撤单标志
		Global_Numeric BKCM,SKCM; //开仓成交手数
		Global_Numeric BKM,SKM; //开仓委托手数
		Global_Numeric BKP,SKP; //开仓委托价格
		Global_Numeric BPID0,BPID1,BPID; //买平委托
		Global_Numeric SPID0,SPID1,SPID; //卖平委托
		Global_Numeric BPFLG0,BPFLG1,BPFLG; //买平标志
		Global_Numeric SPFLG0,SPFLG1,SPFLG; //卖平标志
		Global_Numeric BPDEL0,BPDEL1,BPDEL; //买平撤单标志
		Global_Numeric SPDEL0,SPDEL1,SPDEL; //卖平撤单标志
		Global_Numeric BPCM0,BPCM1,BPCM; //买平成交手数
		Global_Numeric SPCM0,SPCM1,SPCM; //卖平成交手数
		Global_Numeric BPM0,BPM1,BPM; //买平委托手数
		Global_Numeric SPM0,SPM1,SPM; //卖平委托手数
		Global_Numeric BPP0,BPP1,BPP; //买平委托价格
		Global_Numeric SPP0,SPP1,SPP; //卖平委托价格
	Begin
		//------------------获取手动下单信息-----------------//
		If(1)
		{
			If(KPFLG == 0) //如果未开启委托处理
			{
				AID = M_GetTradeAccount(0); //账号
				COD = M_GetTradeContract(); //合约编码
				SIG = M_GetTradeSig(); //下单信号
				VLM = M_GetTradeVol(); //交易手数
				If(VLM > 0 && COD.A_IsExchangeOpen() == 1) //如果交易手数大于0，且当前状态是开盘
				{
					If(SIG == Sig_BK) //如果是买开
					{
						Commentary("【" + COD + "买开：手动买开" + Text(VLM) + "手】");
						BKDFLG = 1; //开启买开处理
					}
					Else If(SIG == Sig_SP) //如果是卖平
					{
						Commentary("【" + COD + "卖平：手动卖平" + Text(VLM) + "手】");
						SPDFLG = 1; //开启卖平处理
					}
					Else If(SIG == Sig_SK) //如果是卖开
					{
						Commentary("【" + COD + "卖开：手动卖开" + Text(VLM) + "手】");
						SKDFLG = 1; //开启卖开处理
					}
					Else If(SIG == Sig_BP) //如果是买平
					{
						Commentary("【" + COD + "买平：手动买平" + Text(VLM) + "手】");
						BPDFLG = 1; //开启买平处理
					}
					KPFLG = 1; //开启委托处理
				}
			}
			If(KPFLG == 1 && COD.A_IsExchangeOpen() == 1) //如果已开启委托处理，且当前状态是开盘
			{
				OPFLG = 1; //开启模型处理
			}
		}
		//---------------------期货变量赋值---------------------//
		If(OPFLG == 1)
		{
			BIDP = COD.Price("Bid1"); //买一价
			ASKP = COD.Price("Ask1"); //卖一价
			BIDV = COD.Price("BidVol1"); //买一量
			ASKV = COD.Price("AskVol1"); //卖一量
			SH = COD.A_IsSHCode(); //上海合约标志
			BRP = COD.A_BuyRemainPosition(AID); //多头可用持仓
			SRP = COD.A_SellRemainPosition(AID); //空头可用持仓
			If(SH == 1) //如果是上期所合约
			{
				BRP0 = COD.A_TodayBuyRemainPosition(AID); //多头今仓可用持仓
				SRP0 = COD.A_TodaySellRemainPosition(AID); //空头今仓可用持仓
				BRP1 = BRP - BRP0; //多头老仓可用持仓
				SRP1 = SRP - SRP0; //空头老仓可用持仓
			}
		}
		//------------------查询组件当前任务-----------------//
		If(OPFLG == 1)
		{
			If(BKFLG == 1) //如果有买开委托
			{
				If(F_OrderStatus(BKID) == Enum_Filled) //如果买开委托成交
				{
					Commentary("【" + COD + "买开：买开委托成交】");
					VLM = VLM - BKM; //买开手数
					BKFLG = 0; //买开标志归0
					BKDEL = 0; //买开撤单标志归0
				}
				Else If(F_OrderStatus(BKID) == Enum_Canceled) //如果买开委托已撤
				{
					Commentary("【" + COD + "买开：买开委托已撤】");
					BKCM = F_OrderFilledLot(BKID); //买开成交手数
					If(BKCM > 0) //如果买开委托部分成交
					{
						BKM = BKM - BKCM; //买开委托手数
						VLM = VLM - BKCM; //买开手数
					}
					BKM = Min(ASKV,BKM); //买开委托手数
					If(BKM > 0) //如果买开委托手数大于0
					{
						BKP = ASKP; //买开委托价格
						Commentary("【" + COD + "买开：公式买开" + Text(BKM) + "手】");
						Commentary("【" + COD + "买开：买开委托追价】");
						BKID = COD.A_SendOrder(Enum_Buy,Enum_Entry,BKM,BKP,AID); //发出买开委托
					}
					BKDEL = 0; //买开撤单标志归0
				}
				Else If(F_OrderStatus(BKID) == Enum_Declared || F_OrderStatus(BKID) == Enum_FillPart) //如果买开委托挂单
				{
					If(BKDEL == 0) //如果未撤单
					{
						If(ASKP != BKP) //如果满足撤单条件
						{
							Commentary("【" + COD + "买开：买开委托撤单】");
							COD.F_DeleteOrder(F_OrderContractNo(BKID),AID); //撤掉买开委托挂单
							BKDEL = 1; //已发出撤掉买开委托挂单
						}
					}
				}
			}
			If(SH == 1) //如果是上期所合约
			{
				If(SPFLG0 == 1) //如果有卖平今仓委托
				{
					If(F_OrderStatus(SPID0) == Enum_Filled) //如果卖平今仓委托成交
					{
						Commentary("【" + COD + "卖平：卖平今仓委托成交】");
						VLM = VLM - SPM0; //卖平手数
						SPFLG0 = 0; //卖平今仓标志归0
						SPDEL0 = 0; //卖平今仓撤单标志归0
					}
					Else If(F_OrderStatus(SPID0) == Enum_Canceled) //如果卖平今仓委托已撤
					{
						Commentary("【" + COD + "卖平：卖平今仓委托已撤】");
						SPCM0 = F_OrderFilledLot(SPID0); //卖平今仓成交手数
						If(SPCM0 > 0) //如果卖平今仓委托部分成交
						{
							SPM0 = SPM0 - SPCM0; //卖平今仓委托手数
							VLM = VLM - SPCM0; //卖平手数
						}
						SPM0 = Min1(BRP0,BIDV,SPM0); //卖平今仓委托手数
						If(BRP0 > 0 && SPM0 > 0) //如果有多头今仓可用持仓，且卖平今仓委托手数大于0
						{
							SPP0 = BIDP; //卖平今仓委托价格
							Commentary("【" + COD + "卖平：公式卖平今仓" + Text(SPM0) + "手】");
							Commentary("【" + COD + "卖平：卖平今仓委托追价】");
							SPID0 = COD.A_SendOrder(Enum_Sell,Enum_ExitToday,SPM0,SPP0,AID); //发出卖平今仓委托
						}
						SPDEL0 = 0; //卖平今仓撤单标志归0
					}
					Else If(F_OrderStatus(SPID0) == Enum_Declared || F_OrderStatus(SPID0) == Enum_FillPart) //如果卖平今仓委托挂单
					{
						If(SPDEL0 == 0) //如果未撤单
						{
							If(BIDP != SPP0) //如果满足撤单条件
							{
								Commentary("【" + COD + "卖平：卖平今仓委托撤单】");
								COD.F_DeleteOrder(F_OrderContractNo(SPID0),AID); //撤掉卖平今仓委托挂单
								SPDEL0 = 1; //已发出撤掉卖平今仓委托挂单
							}
						}
					}
				}
				If(SPFLG1 == 1) //如果有卖平老仓委托
				{
					If(F_OrderStatus(SPID1) == Enum_Filled) //如果卖平老仓委托成交
					{
						Commentary("【" + COD + "卖平：卖平老仓委托成交】");
						VLM = VLM - SPM1; //卖平手数
						SPFLG1 = 0; //卖平老仓标志归0
						SPDEL1 = 0; //卖平老仓撤单标志归0
					}
					Else If(F_OrderStatus(SPID1) == Enum_Canceled) //如果卖平老仓委托已撤
					{
						Commentary("【" + COD + "卖平：卖平老仓委托已撤】");
						SPCM1 = F_OrderFilledLot(SPID1); //卖平老仓成交手数
						If(SPCM1 > 0) //如果卖平老仓委托部分成交
						{
							SPM1 = SPM1 - SPCM1; //卖平老仓委托手数
							VLM = VLM - SPCM1; //卖平手数
						}
						SPM1 = Min1(BRP1,BIDV,SPM1); //卖平老仓委托手数
						If(BRP1 > 0 && SPM1 > 0) //如果有多头老仓可用持仓，且卖平老仓委托手数大于0
						{
							SPP1 = BIDP; //卖平老仓委托价格
							Commentary("【" + COD + "卖平：公式卖平老仓" + Text(SPM1) + "手】");
							Commentary("【" + COD + "卖平：卖平老仓委托追价】");
							SPID1 = COD.A_SendOrder(Enum_Sell,Enum_Exit,SPM1,SPP1,AID); //发出卖平老仓委托
						}
						SPDEL1 = 0; //卖平老仓撤单标志归0
					}
					Else If(F_OrderStatus(SPID1) == Enum_Declared || F_OrderStatus(SPID1) == Enum_FillPart) //如果卖平老仓委托挂单
					{
						If(SPDEL1 == 0) //如果未撤单
						{
							If(BIDP != SPP1) //如果满足撤单条件
							{
								Commentary("【" + COD + "卖平：卖平老仓委托撤单】");
								COD.F_DeleteOrder(F_OrderContractNo(SPID1),AID); //撤掉卖平老仓委托挂单
								SPDEL1 = 1; //已发出撤掉卖平老仓委托挂单
							}
						}
					}
				}
			}
			Else //如果非上期所合约
			{
				If(SPFLG == 1) //如果有卖平委托
				{
					If(F_OrderStatus(SPID) == Enum_Filled) //如果卖平委托成交
					{
						Commentary("【" + COD + "卖平：卖平委托成交】");
						VLM = VLM - SPM; //卖平手数
						SPFLG = 0; //卖平标志归0
						SPDEL = 0; //卖平撤单标志归0
					}
					Else If(F_OrderStatus(SPID) == Enum_Canceled) //如果卖平委托已撤
					{
						Commentary("【" + COD + "卖平：卖平委托已撤】");
						SPCM = F_OrderFilledLot(SPID); //卖平成交手数
						If(SPCM > 0) //如果卖平委托部分成交
						{
							SPM = SPM - SPCM; //卖平委托手数
							VLM = VLM - SPCM; //卖平手数
						}
						SPM = Min1(BRP,BIDV,SPM); //卖平委托手数
						If(BRP > 0 && SPM > 0) //如果有多头可用持仓，且卖平委托手数大于0
						{
							SPP = BIDP; //卖平委托价格
							Commentary("【" + COD + "卖平：公式卖平" + Text(SPM) + "手】");
							Commentary("【" + COD + "卖平：卖平委托追价】");
							SPID = COD.A_SendOrder(Enum_Sell,Enum_Exit,SPM,SPP,AID); //发出卖平委托
						}
						SPDEL = 0; //卖平撤单标志归0
					}
					Else If(F_OrderStatus(SPID) == Enum_Declared || F_OrderStatus(SPID) == Enum_FillPart) //如果卖平委托挂单
					{
						If(SPDEL == 0) //如果未撤单
						{
							If(BIDP != SPP) //如果满足撤单条件
							{
								Commentary("【" + COD + "卖平：卖平委托撤单】");
								COD.F_DeleteOrder(F_OrderContractNo(SPID),AID); //撤掉卖平委托挂单
								SPDEL = 1; //已发出撤掉卖平委托挂单
							}
						}
					}
				}
			}
			If(SKFLG == 1) //如果有卖开委托
			{
				If(F_OrderStatus(SKID) == Enum_Filled) //如果卖开委托成交
				{
					Commentary("【" + COD + "卖开：卖开委托成交】");
					VLM = VLM - SKM; //卖开手数
					SKFLG = 0; //卖开标志归0
					SKDEL = 0; //卖开撤单标志归0
				}
				Else If(F_OrderStatus(SKID) == Enum_Canceled) //如果卖开委托已撤
				{
					Commentary("【" + COD + "卖开：卖开委托已撤】");
					SKCM = F_OrderFilledLot(SKID); //卖开成交手数
					If(SKCM > 0) //如果卖开委托部分成交
					{
						SKM = SKM - SKCM; //卖开委托手数
						VLM = VLM - SKCM; //卖开手数
					}
					SKM = Min(BIDV,SKM); //卖开委托手数
					If(SKM > 0) //如果卖开委托手数大于0
					{
						SKP = BIDP; //卖开委托价格
						Commentary("【" + COD + "卖开：公式卖开" + Text(SKM) + "手】");
						Commentary("【" + COD + "卖开：卖开委托追价】");
						SKID = COD.A_SendOrder(Enum_Sell,Enum_Entry,SKM,SKP,AID); //发出卖开委托
					}
					SKDEL = 0; //卖开撤单标志归0
				}
				Else If(F_OrderStatus(SKID) == Enum_Declared || F_OrderStatus(SKID) == Enum_FillPart) //如果卖开委托挂单
				{
					If(SKDEL == 0) //如果未撤单
					{
						If(BIDP != SKP) //如果满足撤单条件
						{
							Commentary("【" + COD + "卖开：卖开委托撤单】");
							COD.F_DeleteOrder(F_OrderContractNo(SKID),AID); //撤掉卖开委托挂单
							SKDEL = 1; //已发出撤掉卖开委托挂单
						}
					}
				}
			}
			If(SH == 1) //如果是上期所合约
			{
				If(BPFLG0 == 1) //如果有买平今仓委托
				{
					If(F_OrderStatus(BPID0) == Enum_Filled) //如果买平今仓委托成交
					{
						Commentary("【" + COD + "买平：买平今仓委托成交】");
						VLM = VLM - BPM0; //买平手数
						BPFLG0 = 0; //买平今仓标志归0
						BPDEL0 = 0; //买平今仓撤单标志归0
					}
					Else If(F_OrderStatus(BPID0) == Enum_Canceled) //如果买平今仓委托已撤
					{
						Commentary("【" + COD + "买平：买平今仓委托已撤】");
						BPCM0 = F_OrderFilledLot(BPID0); //买平今仓成交手数
						If(BPCM0 > 0) //如果买平今仓委托部分成交
						{
							BPM0 = BPM0 - BPCM0; //买平今仓委托手数
							VLM = VLM - BPCM0; //买平手数
						}
						BPM0 = Min1(SRP0,ASKV,BPM0); //买平今仓委托手数
						If(SRP0 > 0 && BPM0 > 0) //如果有空头今仓可用持仓，且买平今仓委托手数大于0
						{
							BPP0 = ASKP; //买平今仓委托价格
							Commentary("【" + COD + "买平：公式买平今仓" + Text(BPM0) + "手】");
							Commentary("【" + COD + "买平：买平今仓委托追价】");
							BPID0 = COD.A_SendOrder(Enum_Buy,Enum_ExitToday,BPM0,BPP0,AID); //发出买平今仓委托
						}
						BPDEL0 = 0; //买平今仓撤单标志归0
					}
					Else If(F_OrderStatus(BPID0) == Enum_Declared || F_OrderStatus(BPID0) == Enum_FillPart) //如果买平今仓委托挂单
					{
						If(BPDEL0 == 0) //如果未撤单
						{
							If(ASKP != BPP0) //如果满足撤单条件
							{
								Commentary("【" + COD + "买平：买平今仓委托撤单】");
								COD.F_DeleteOrder(F_OrderContractNo(BPID0),AID); //撤掉买平今仓委托挂单
								BPDEL0 = 1; //已发出撤掉买平今仓委托挂单
							}
						}
					}
				}
				If(BPFLG1 == 1) //如果有买平老仓委托
				{
					If(F_OrderStatus(BPID1) == Enum_Filled) //如果买平老仓委托成交
					{
						Commentary("【" + COD + "买平：买平老仓委托成交】");
						VLM = VLM - BPM1; //买平手数
						BPFLG1 = 0; //买平老仓标志归0
						BPDEL1 = 0; //买平老仓撤单标志归0
					}
					Else If(F_OrderStatus(BPID1) == Enum_Canceled) //如果买平老仓委托已撤
					{
						Commentary("【" + COD + "买平：买平老仓委托已撤】");
						BPCM1 = F_OrderFilledLot(BPID1); //买平老仓成交手数
						If(BPCM1 > 0) //如果买平老仓委托部分成交
						{
							BPM1 = BPM1 - BPCM1; //买平老仓委托手数
							VLM = VLM - BPCM1; //买平手数
						}
						BPM1 = Min1(SRP1,ASKV,BPM1); //买平老仓委托手数
						If(SRP1 > 0 && BPM1 > 0) //如果有空头老仓可用持仓，且买平老仓委托手数大于0
						{
							BPP1 = ASKP; //买平老仓委托价格
							Commentary("【" + COD + "买平：公式买平老仓" + Text(BPM1) + "手】");
							Commentary("【" + COD + "买平：买平老仓委托追价】");
							BPID1 = COD.A_SendOrder(Enum_Buy,Enum_Exit,BPM1,BPP1,AID); //发出买平老仓委托
						}
						BPDEL1 = 0; //买平老仓撤单标志归0
					}
					Else If(F_OrderStatus(BPID1) == Enum_Declared || F_OrderStatus(BPID1) == Enum_FillPart) //如果买平老仓委托挂单
					{
						If(BPDEL1 == 0) //如果未撤单
						{
							If(ASKP != BPP1) //如果满足撤单条件
							{
								Commentary("【" + COD + "买平：买平老仓委托撤单】");
								COD.F_DeleteOrder(F_OrderContractNo(BPID1),AID); //撤掉买平老仓委托挂单
								BPDEL1 = 1; //已发出撤掉买平老仓委托挂单
							}
						}
					}
				}
			}
			Else //如果非上期所合约
			{
				If(BPFLG == 1) //如果有买平委托
				{
					If(F_OrderStatus(BPID) == Enum_Filled) //如果买平委托成交
					{
						Commentary("【" + COD + "买平：买平委托成交】");
						VLM = VLM - BPM; //买平手数
						BPFLG = 0; //买平标志归0
						BPDEL = 0; //买平撤单标志归0
					}
					Else If(F_OrderStatus(BPID) == Enum_Canceled) //如果买平委托已撤
					{
						Commentary("【" + COD + "买平：买平委托已撤】");
						BPCM = F_OrderFilledLot(BPID); //买平成交手数
						If(BPCM > 0) //如果买平委托部分成交
						{
							BPM = BPM - BPCM; //买平委托手数
							VLM = VLM - BPCM; //买平手数
						}
						BPM = Min1(SRP,ASKV,BPM); //买平委托手数
						If(SRP > 0 && BPM > 0) //如果有空头可用持仓，且买平委托手数大于0
						{
							BPP = ASKP; //买平委托价格
							Commentary("【" + COD + "买平：公式买平" + Text(BPM) + "手】");
							Commentary("【" + COD + "买平：买平委托追价】");
							BPID = COD.A_SendOrder(Enum_Buy,Enum_Exit,BPM,BPP,AID); //发出买平委托
						}
						BPDEL = 0; //买平撤单标志归0
					}
					Else If(F_OrderStatus(BPID) == Enum_Declared || F_OrderStatus(BPID) == Enum_FillPart) //如果买平委托挂单
					{
						If(BPDEL == 0) //如果未撤单
						{
							If(ASKP != BPP) //如果满足撤单条件
							{
								Commentary("【" + COD + "买平：买平委托撤单】");
								COD.F_DeleteOrder(F_OrderContractNo(BPID),AID); //撤掉买平委托挂单
								BPDEL = 1; //已发出撤掉买平委托挂单
							}
						}
					}
				}
			}
		}
		//------------------------委托发出------------------------//
		If(OPFLG == 1)
		{
			//---------------------买开委托处理--------------------//
			If(BKDFLG == 1) //如果已开启买开处理
			{
				If(BKFLG == 0) //如果没有买开委托
				{
					//------------------------买开委托发出------------------------//
					If(1)
					{
						BKM = Min(ASKV,VLM); //买开委托手数
						If(BKM > 0) //如果买开委托手数大于0
						{
							BKP = ASKP; //买开委托价格
							Commentary("【" + COD + "买开：公式买开" + Text(BKM) + "手】");
							Commentary("【" + COD + "买开：买开委托发出】");
							BKID = COD.A_SendOrder(Enum_Buy,Enum_Entry,BKM,BKP,AID); //发出买开委托
							BKFLG = 1; //已发出买开委托
						}
						Else If(BKM == 0) //如果买开委托手数等于0
						{
							Commentary("【" + COD + "买开：买开委托完成】");
							Exit(); //退出公式
						}
					}
				}
			}
			//---------------------卖平委托处理--------------------//
			If(SPDFLG > 0) //如果已开启卖平处理
			{
				If(SPFLG0 == 0 && SPFLG1 == 0 && SPFLG == 0) //如果没有卖平委托
				{
					//------------------------卖平委托发出------------------------//
					If(1)
					{
						SPM = Min(BIDV,VLM); //卖平委托手数
						If(BRP > 0 && SPM > 0) //如果有多头可用持仓，且卖平委托手数大于0
						{
							If(SH == 1) //如果是上期所合约
							{
								If(BRP0 > 0) //如果有多头今仓可用持仓
								{
									SPM0 = Min(SPM,BRP0); //卖平今仓委托手数
									SPM1 = Min(SPM - SPM0,BRP1); //卖平老仓委托手数
									SPP0 = BIDP; //卖平今仓委托价格
									Commentary("【" + COD + "卖平：公式卖平今仓" + Text(SPM0) + "手】");
									Commentary("【" + COD + "卖平：卖平今仓委托发出】");
									SPID0 = COD.A_SendOrder(Enum_Sell,Enum_ExitToday,SPM0,SPP0,AID); //发出卖平今仓委托
									SPFLG0 = 1; //已发出卖平今仓委托
								}
								Else If(BRP0 == 0) //如果没有多头今仓可用持仓
								{
									SPM1 = Min(SPM,BRP1); //卖平老仓委托手数
								}
								If(BRP1 > 0 && SPM1 > 0) //如果有多头老仓可用持仓，且卖平老仓委托手数大于0
								{
									SPP1 = BIDP; //卖平老仓委托价格
									Commentary("【" + COD + "卖平：公式卖平老仓" + Text(SPM1) + "手】");
									Commentary("【" + COD + "卖平：卖平老仓委托发出】");
									SPID1 = COD.A_SendOrder(Enum_Sell,Enum_Exit,SPM1,SPP1,AID); //发出卖平老仓委托
									SPFLG1 = 1; //已发出卖平老仓委托
								}
							}
							Else //如果非上期所合约
							{
								SPM = Min(SPM,BRP); //卖平委托手数
								SPP = BIDP; //卖平委托价格
								Commentary("【" + COD + "卖平：公式卖平" + Text(SPM) + "手】");
								Commentary("【" + COD + "卖平：卖平委托发出】");
								SPID = COD.A_SendOrder(Enum_Sell,Enum_Exit,SPM,SPP,AID); //发出卖平委托
								SPFLG = 1; //已发出卖平委托
							}
						}
						Else If(BRP == 0 || SPM == 0) //如果没有多头可用持仓，或卖平委托手数等于0
						{
							Commentary("【" + COD + "卖平：卖平委托完成】");
							Exit(); //退出公式
						}
					}
				}
			}
			//---------------------卖开委托处理--------------------//
			If(SKDFLG == 1) //如果已开启卖开处理
			{
				If(SKFLG == 0) //如果没有卖开委托
				{
					//------------------------卖开委托发出------------------------//
					If(1)
					{
						SKM = Min(BIDV,VLM); //卖开委托手数
						If(SKM > 0) //如果卖开委托手数大于0
						{
							SKP = BIDP; //卖开委托价格
							Commentary("【" + COD + "卖开：公式卖开" + Text(SKM) + "手】");
							Commentary("【" + COD + "卖开：卖开委托发出】");
							SKID = COD.A_SendOrder(Enum_Sell,Enum_Entry,SKM,SKP,AID); //发出卖开委托
							SKFLG = 1; //已发出卖开委托
						}
						Else If(SKM == 0) //如果卖开委托手数等于0
						{
							Commentary("【" + COD + "卖开：卖开委托完成】");
							Exit(); //退出公式
						}
					}
				}
			}
			//---------------------买平委托处理--------------------//
			If(BPDFLG > 0) //如果已开启买平处理
			{
				If(BPFLG0 == 0 && BPFLG1 == 0 && BPFLG == 0) //如果没有买平委托
				{
					//------------------------买平委托发出------------------------//
					If(1)
					{
						BPM = Min(ASKV,VLM); //买平委托手数
						If(SRP > 0 && BPM > 0) //如果有空头可用持仓，且买平委托手数大于0
						{
							If(SH == 1) //如果是上期所合约
							{
								If(SRP0 > 0) //如果有空头今仓可用持仓
								{
									BPM0 = Min(BPM,SRP0); //买平今仓委托手数
									BPM1 = Min(BPM - BPM0,SRP1); //买平老仓委托手数
									BPP0 = ASKP; //买平今仓委托价格
									Commentary("【" + COD + "买平：公式买平今仓" + Text(BPM0) + "手】");
									Commentary("【" + COD + "买平：买平今仓委托发出】");
									BPID0 = COD.A_SendOrder(Enum_Buy,Enum_ExitToday,BPM0,BPP0,AID); //发出买平今仓委托
									BPFLG0 = 1; //已发出买平今仓委托
								}
								Else If(SRP0 == 0) //如果没有空头今仓可用持仓
								{
									BPM1 = Min(BPM,SRP1); //买平老仓委托手数
								}
								If(SRP1 > 0 && BPM1 > 0) //如果有空头老仓可用持仓，且买平老仓委托手数大于0
								{
									BPP1 = ASKP; //买平老仓委托价格
									Commentary("【" + COD + "买平：公式买平老仓" + Text(BPM1) + "手】");
									Commentary("【" + COD + "买平：买平老仓委托发出】");
									BPID1 = COD.A_SendOrder(Enum_Buy,Enum_Exit,BPM1,BPP1,AID); //发出买平老仓委托
									BPFLG1 = 1; //已发出买平老仓委托
								}
							}
							Else //如果非上期所合约
							{
								BPM = Min(BPM,SRP); //买平委托手数
								BPP = ASKP; //买平委托价格
								Commentary("【" + COD + "买平：公式买平" + Text(BPM) + "手】");
								Commentary("【" + COD + "买平：买平委托发出】");
								BPID = COD.A_SendOrder(Enum_Buy,Enum_Exit,BPM,BPP,AID); //发出买平委托
								BPFLG = 1; //已发出买平委托
							}
						}
						Else If(SRP == 0 || BPM == 0) //如果没有空头可用持仓，或买平委托手数等于0
						{
							Commentary("【" + COD + "买平：买平委托完成】");
							Exit(); //退出公式
						}
					}
				}
			}
		}
	End
						</pre
                  >
                  <br />
                  <div class="paragraph">
                    通过右上方菜单【量化】->【算法交易运行池】->【算法交易下单】，调出算法交易下单界面，按下图所示方法实现手动下单调用算法交易：
                  </div>

                  <div class="img_center click_bigimg">
                    <img src="./imageswh9/jiaoyi2.jpg" />
                  </div>

                  <div class="paragraph">注：</div>
                  <div class="paragraph">
                    ①如果再次下单，会再次加载该模型，不会直接在前一个算法交易模型中继续执行。
                  </div>
                  <div class="paragraph">
                    ②如果模型中含有函数Exit()，则模型执行完毕后会自动退出。
                  </div>
                </div>
                <div class="case_box">
                  <div class="first">案例二：手动下单+多账号分批算法</div>
                  <div class="paragraph">
                    算法交易也支持多账号智能分批，既可以对多个账号进行分组，设定不同的委托手数倍率，也可以根据对手盘情况实时计算每一批的总手数，实现多账号智能分批、统一管理。
                  </div>
                  <div class="paragraph">例如：</div>
                  <div class="paragraph">
                    我们有三个交易账号需要同时开仓，三个交易账号的委托手数倍率分别为1、1.5、2.5。我们可在多账号下单界面中勾选要参与交易的账号，并设定好下单倍率。
                  </div>

                  <div class="img_center">
                    <img src="./imageswh9/jiaoyi3.jpg" width="630" />
                  </div>

                  <div class="paragraph">
                    我们可以一键对这三个账号一起进行智能分批下单。
                  </div>
                  <div class="paragraph">
                    首先，要求每批的总手数不超过盘口对手盘量的20%。首批三个账户按照1
                    : 1.5 ：2.5的比例进行下单。
                  </div>
                  <div class="paragraph">
                    其次，任何一个账号第一批成交以后（三个账号不一定同时都成交），第二批委托数量为对手盘量的20%乘以该账号的比例，直到全部成交。
                  </div>
                  <div class="paragraph">
                    最后，任何一个账号如3秒未全部成交，则执行追价策略确保成交。
                  </div>
                  <div class="paragraph">
                    这样既保证了总手数不对趋势造成影响，也同时完成了三个账号的分批建仓。
                  </div>
                  <br />
                  <div
                    class="title expand"
                    style="width: auto; justify-content: left"
                  >
                    代码如下：
                    <div class="extendCodeBtn" @click="dropdowncode(3)">点击展开源码</div>
                  </div>
                  <pre v-show="showcode[3]">
	Vars
		Global_StringArray AID; //账号
		Global_String COD; //合约编码
		Numeric SIG; //下单信号
		Numeric VLM; //交易手数
		Numeric X; //循环变量
		Numeric T; //时间间隔
		Numeric P; //数值比例
		Numeric NOW; //当前时间
		Numeric ASKP; //卖一价
		Numeric ASKV; //卖一量
		Numeric ODFLG; //挂单判断标志
		Numeric OPFLG; //模型处理标志
		Global_Numeric ADN; //账号数量
		Global_Numeric TP; //下单总倍数
		Global_Numeric KPFLG; //委托处理标志
		Global_Numeric BKDFLG; //买开处理标志
		Global_NumericArray NP; //下单倍数
		Global_NumericArray BKID; //买开委托
		Global_NumericArray BKFLG; //买开标志
		Global_NumericArray BKDEL; //买开撤单标志
		Global_NumericArray BKSM; //买开总手数
		Global_NumericArray BKM; //买开委托手数
		Global_NumericArray BKP; //买开委托价格
		Global_NumericArray BKT; //买开委托时间
	Begin
		//------------------获取手动下单信息-----------------//
		If(1)
		{
			If(KPFLG == 0) //如果未开启委托处理
			{
				ADN = M_GetTradeAccountNum; //账号数量
				COD = M_GetTradeContract(); //合约编码
				SIG = M_GetTradeSig(); //下单信号
				VLM = M_GetTradeVol(); //交易手数
				For X = 0 To ADN - 1 //遍历账号
				{
					AID[X] = M_GetTradeAccount(X); //账号
					NP[X] = M_GetTradeOrderRatio(X);//下单倍数
					BKSM[X] = NP[X] * VLM; //买开总手数
					TP = TP + NP[X]; //下单总倍数
				}
				If(VLM > 0 && COD.A_IsExchangeOpen() == 1)//如果交易手数大于0，且当前状态是开盘
				{
					If(SIG == Sig_BK)//如果是买开方向
					{
						Commentary("【" + COD +"买开：手动买开" + Text(VLM) + "手！】");
						BKDFLG = 1;//开启买开处理
					}
					KPFLG = 1; //开启委托处理
				}
			}
			If(KPFLG == 1 && COD.A_IsExchangeOpen() == 1) //如果已开启委托处理，且当前状态是开盘
			{
				OPFLG = 1; //开启模型处理
			}
		}
		//---------------------期货变量赋值---------------------//
		If(OPFLG == 1) //变量赋值
		{
			T = 3; //时间间隔
			P = 0.2; //数值比例
			NOW = CurrentTime(); //当前时间
			ASKP = COD.Price("Ask1"); //卖一价
			ASKV = COD.Price("AskVol1"); //卖一量
		}
		//------------------查询组件当前任务-----------------//
		If(OPFLG == 1)
		{
			For X = 0 To ADN - 1 //遍历账号
			{
				If(BKFLG[X] == 1) //如果有买开委托
				{
					If(F_OrderStatus(BKID[X]) == Enum_Filled)//如果买开委托成交
					{
						Commentary("【" + COD + "买开：买开委托成交！" + AID[X] + "】");
						BKFLG[X] = 0;//买开标志归0
						BKDEL[X] = 0;//买开撤单标志归0
					}
					Else If(F_OrderStatus(BKID[X]) == Enum_Canceled) //如果买开委托已撤
					{
						Commentary("【" + COD + "买开：买开委托已撤！" + AID[X] + "】");
						If(F_OrderFilledLot(BKID[X]) > 0) //如果买开委托部分成交
						{
							BKM[X] = BKM[X] - F_OrderFilledLot(BKID[X]); //买开委托手数
						}
						If(BKM[X] > 0) //如果买开委托手数大于0
						{
							BKP[X] = ASKP; //买开委托价格
							Commentary("【" + COD + "买开：买开委托追价！" + AID[X] + "】");
							BKID[X] = COD.A_SendOrder(Enum_Buy,Enum_Entry,BKM[X],BKP[X],AID[X]); //发出买开委托
							BKT[X] = NOW; //买开委托时间
						}
						BKDEL[X] = 0; //买开撤单标志归0
					}
					Else If(F_OrderStatus(BKID[X]) == Enum_Declared || F_OrderStatus(BKID[X]) == Enum_FillPart) //如果买开委托挂单
					{
						If(BKDEL[X] == 0) //如果未撤单
						{
							If(TimeDiff(BKT[X],NOW) >= T) //如果时间间隔T秒
							{
								Commentary("【" + COD + "买开：买开委托撤单！" + AID[X] + "】");
								COD.F_DeleteOrder(F_OrderContractNo(BKID[X]),AID[X]); //撤掉买开委托挂单
								BKDEL[X] = 1; //已发出撤掉买开委托挂单
							}
						}
					}
				}
			}
			ODFLG = 1; //挂单判断标志初始化
			For X = 0 To ADN - 1 //遍历账号
			{
				If(BKFLG[X] == 1 || BKSM[X] > 0) //如果有买开委托，或有剩余买开手数
				{
					ODFLG = 2; //存在买开委托挂单
				}
			}
			If(ODFLG == 1) //如果没有买开委托
			{
				Commentary("【" + COD + "买开：买开委托完成！】");
				BKDFLG = 0; //买开处理标志归0
				Exit(); //退出公式
			}
		}
		//------------------------委托发出------------------------//
		If(OPFLG == 1) //委托处理
		{
			//---------------------买开委托处理--------------------//
			If(BKDFLG == 1) //如果已开启买开处理
			{
				For X = 0 To ADN - 1 //遍历账号
				{
					If(BKFLG[X] == 0) //如果没有买开委托
					{
						//------------------------买开委托发出------------------------//
						If(1)
						{
							If(TP > 0) //如果已取得下单总倍数
							{
								BKM[X] = Min(Floor((NP[X] / TP) * P * ASKV),BKSM[X]); //买开委托手数
							}
							If(BKM[X] > 0) //如果买开委托手数大于0
							{
								BKP[X] = ASKP; //买开委托价格
								Commentary("【" + COD + "买开：公式买开" + Text(BKM[X]) + "手！" + AID[X] + "】");
								Commentary("【" + COD + "买开：买开委托发出！" + AID[X] + "】");
								BKID[X] = COD.A_SendOrder(Enum_Buy,Enum_Entry,BKM[X],BKP[X],AID[X]); //发出买开委托
								BKSM[X] = BKSM[X] - BKM[X]; //买开总手数
								BKT[X] = NOW; //买开委托时间
								BKFLG[X] = 1; //已发出买开委托
							}
						}
					}
				}
			}
		}
	End
						</pre
                  >

                  <div class="img_center click_bigimg">
                    <img src="./imageswh9/jiaoyi4.jpg" width="630" />
                  </div>
                </div>
              </div>

              <div v-if="id == 3 && tabId == 0">
                
                <div class="paragraph">
                  <common-data name="appShortName_17"/>软件以Tick精准历史回测为基础，可进行多品种、多模型、多周期任意组合的测试。还提供风险分析、盈利分析、相关性分析等分析工具，从多个角度解析组合的内在逻辑，寻求优化模型，搭建最优投资组合。
                </div>
                <div class="case_box">
                  <div class="first">案例1：批量回测工具操作手册</div>
                  <div class="first">1、一篮子合约批量回测</div>
                  <div class="paragraph">
                    用同一个模型对一篮子合约进行批量回测，筛选最佳交易合约。回测后每一个合约都生成一份独立的回测报告和独立的资金曲线图。
                  </div>

                  <BaseBigimg
                    :src="require('./imageswh9/img5.jpg')"
                  ></BaseBigimg>

                  <div class="first">2、一篮子模型批量回测</div>
                  <div class="paragraph">
                    用多个模型对同一合约进行批量回测，筛选适合该合约的交易模型。软件提供每个模型的回测报告，分项统计图表、时段统计图表，以及k线图供分析，且支持一键加入到模组运行。
                  </div>

                  <div class="img_center">
                    <img src="./imageswh9/imgb.jpg" />
                  </div>

                  <BaseBigimg
                    :src="require('./imageswh9/img6.jpg')"
                  ></BaseBigimg>
                </div>
                <div class="case_box">
                  <div class="first">案例2：组合配置分析工具使用方法</div>
                  <div class="first">1、组合配置操作步骤</div>

                  <div class="img_center">
                    <img src="./imageswh9/img7.jpg" />
                  </div>

                  <div class="img_center">
                    <img src="./imageswh9/img8.jpg" />
                  </div>

                  <div class="img_center">
                    <img src="./imageswh9/img9.jpg" />
                  </div>

                  <div class="first">2、组合资金曲线计算方式</div>

                  <div class="img_center">
                    <img src="./imageswh9/img10.jpg" />
                  </div>

                  <div class="paragraph">
                    权益资金曲线，记录每根K线上的权益波动；
                  </div>
                  <div class="paragraph">
                    损益曲线，记录平仓盈亏累加值的波动，每完整交易一次则统计一次；
                  </div>
                  <div class="paragraph">
                    收益曲线，展示模型的累计收益情况（浮盈+累计平仓盈亏-手续费）；
                  </div>
                  <div class="paragraph">
                    净值曲线，刨除出入金对组合的收益影响，展示组合的真实盈利效果；
                  </div>
                  <div class="paragraph">
                    显示保证金占比，在资金曲线图下方显示保证金占比柱状图，便于分析资金占用情况，调控资金分配；
                  </div>
                  <div class="paragraph">
                    资金详细信息，记录每根K线上的组合资金概况和组合中所有模型的具体交易信息。
                  </div>
                  <br />
                  <div class="first">3、风险分析工具的使用</div>
                  <div class="paragraph">
                    风权益回撤和权益回撤比分析，提供单元、品种、板块、策略四个维度视角的风险分析，对每个模型进行打分，直观的了解各个单元、品种、板块、策略的风险回撤程度，回撤贡献度分数越低说明回撤越小，贡献越大。
                  </div>

                  <BaseBigimg
                    :src="require('./imageswh9/zhpz-1.jpg')"
                  ></BaseBigimg>

                  <div class="first">回撤贡献度得分算法：</div>
                  <div class="paragraph">
                    每个模型在每个时点上比较，回撤值最大的得1分，次之得2分，以此类推。每个模型总分就是每个时点得分之和。如在某一个时点上，模型A的回撤大，模型B的回撤小，那么模型A得1分，模型B得2分。每个时点上都会计算得分，模型A和模型B的得分分别加和就是各自的总得分。得分高说明模型的回撤小，贡献大。
                  </div>
                  <div class="paragraph">
                    注：回撤值=回撤前的最大权益-当前权益
                  </div>
                  <br />
                  <div class="first">回撤比贡献度得分算法：</div>
                  <div class="paragraph">
                    回撤比贡献度以每个时点的最大回撤比（最大回撤/最大回撤前的最大权益）做比较，计算各个点的得分之后加起来计算总得分。
                  </div>
                  <br />
                  <div class="first">4、盈利分析工具的使用</div>
                  <div class="paragraph">（1）盈利分析</div>
                  <div class="paragraph">
                    盈利分析图表计算每个模型盈利贡献（盈利贡献度=模型盈利/组合总盈利），支持从单元、品种、板块、策略四个维度视角查看盈利状况。
                  </div>

                  <BaseBigimg
                    :src="require('./imageswh9/zhpz-2.jpg')"
                  ></BaseBigimg>

                  <div class="paragraph">
                    注：组合盈利小于0时，盈利分析图不显示盈利贡献度百分比，只显示具体盈利数值。
                  </div>

                  <div class="paragraph">（2）盈利-胜率分析</div>
                  <div class="paragraph">
                    盈利-胜率分析，支持从胜率、盈亏比多维度分析组合成员的盈利贡献情况，直观了解组合单元、板块、品种、策略的盈利概率和盈利能力。
                  </div>

                  <BaseBigimg
                    :src="require('./imageswh9/zhpz-3.jpg')"
                  ></BaseBigimg>

                  <br />
                  <div class="first">5、相关性分析工具的使用</div>
                  <div class="paragraph">
                    组合配置提供相关性分析，统计模型收益率的相关性大小，分析组合的风险分散效果。方便用户根据模型的相关性强弱，调整组合成员，优化模型结构，分散组合风险。
                  </div>

                  <div class="img_center">
                    <img src="./imageswh9/img14.jpg" />
                  </div>
                </div>
              </div>
              <div v-if="id == 3 && tabId == 1">
                
                <div class="paragraph">
                  <common-data name="appShortName_17"/>不仅支持单模型的参数优化，还提供了基于遗传规划算法的组合参数优化，通过设定初始种群、最大遗传代数、参考标准等参数，可对模型组合进行参数优化，自动计算最优参数，制定最优定参计划。
                </div>
                <div class="case_box">
                  <div class="first">案例：组合参数优化操作步骤</div>
                  <div class="paragraph">
                    1、在组合配置窗口，点击左下角【组合参数优化】按钮。
                  </div>

                  <BaseBigimg
                    :src="require('./imageswh9/img15.jpg')"
                  ></BaseBigimg>
                  <div class="paragraph">
                    2、选择需要进行参数优化的模型，设定初始种群、最大遗产代数、参考标准，系统将自动机计算计算次数，以及启用的线程数。
                  </div>

                  <BaseBigimg
                    :src="require('./imageswh9/img16.jpg')"
                  ></BaseBigimg>
                  <div class="paragraph">
                    3、计算结果支持排序，或右键保存到备用参数组中。
                  </div>
                </div>
              </div>
              <div v-if="id == 4 && tabId == 0">
                
                <div class="paragraph">
                  在模型中使用头寸管理函数实现资金管理，在模组中对运行单元进行出入金操作可实现资管产品的申购/赎回管理。
                </div>
                <div class="case_box">
                  <div class="first">案例：资管产品的申购/赎回处理</div>
                  <div class="paragraph">
                    模型中使用头寸管理函数实现按理论资金比例下单，当一只资管产品需要进行申购/赎回时，可在运行单元的资金管理界面，对该产品的运行单元进行出入金操作，后续的开仓指令，模型会根据调整后的资金重新计算下单手数。
                  </div>
                  <div class="paragraph">
                    投资经理可以根据每个运行单元的实盘运行情况，调整出入金的金额，并汇总查看此次申购/赎回的总金额。
                  </div>

                  <BaseBigimg
                    :src="require('./imageswh9/zjgl1.jpg')"
                  ></BaseBigimg>
                </div>
              </div>

              <div v-if="id == 5 && tabId == 0">
                
                <div class="paragraph">
                  <common-data name="appShortName_17"/>模组根据实盘交易数据，绘制每个运行单元的实盘收益曲线。为投资经理了解模型真实收益情况、调整模型参数、优化模型组合、制定资金再分配计划提供了决策依据。
                </div>
                <div class="case_box">
                  <div class="first">案例：查看模型真实收益，优化模型组合</div>
                  <div class="paragraph">
                    模型组合实盘运行一段时间后，投资经理可查看每个模型运行单元的实盘收益情况，对模型组合进行调整，及时剔除连续亏损或已经失效的模型，降低投资风险；也可将更多资金分配给实盘收益稳定，回撤小的模型，获得更多超额收益。
                  </div>
                  <div class="paragraph">
                    在模组的运行单元中点击鼠标右键，可选择收益分析功能。
                  </div>

                  <BaseBigimg
                    :src="require('./imageswh9/syfx1.jpg')"
                  ></BaseBigimg>

                  <div class="paragraph">
                    在收益分析界面支持勾选当前/所有分区下的运行单元，使用选中运行单元信号下单的真实成交记录，绘制实际交易的收益曲线。
                  </div>

                  <BaseBigimg
                    :src="require('./imageswh9/syfx2.jpg')"
                  ></BaseBigimg>
                  <div class="first">收益分析算法说明：</div>
                  <div class="first">（1）账号收益部分</div>
                  <div class="paragraph">权益 = 分配资金 + 出入金 + 收益</div>
                  <div class="paragraph">
                    可用资金 = 权益 - 每个单元当前的保证金占用
                  </div>
                  <div class="paragraph">
                    资金使用率 = 每个单元当前的保证金占用 / 权益
                  </div>
                  <div class="paragraph">
                    最大回撤比 =
                    （权益最大回撤/权益最大回撤时的最大权益）的最大值，按日统计
                  </div>
                  <div class="first">
                    （2）单元交易统计（通过信号记录统计中的信号理论计算）
                  </div>
                  <div class="paragraph">交易次数 = 按一次完整交易统计次数</div>
                  <div class="paragraph">胜率 = 非亏损交易次数/总交易次数</div>
                  <div class="paragraph">
                    盈亏比率 = (总盈利/总盈利次数)/(总亏损/总亏损次数)
                  </div>
                  <div class="paragraph">
                    收益率 =
                    收益/（最大保证金占用资金/单元资金使用率），最大保证金占用资金是单元实际下单记录中最大的保证金占用金额。
                  </div>
                  <div class="paragraph">合计行算法：</div>
                  <div class="paragraph">交易次数 = sum(交易次数)</div>
                  <div class="paragraph">
                    胜率 = sum(非亏损交易次数)/sum(交易次数)
                  </div>
                  <div class="paragraph">
                    盈亏比率 =
                    (sum(总盈利)/sum(总盈利次数))/((sum(总亏损)/sum(总亏损次数)))
                  </div>
                  <div class="paragraph">
                    收益率 = sum(收益)/(sum(最大保证金)/单元资金使用率)。
                  </div>
                </div>
              </div>

              <div v-if="id == 6 && tabId == 0">
                
                <div class="paragraph">
                  模组既是基金经理的模型运行管理平台，也是交易员监控模型运行状态的工具。模组列表式的管理界面，对各个模型的运行集中管理，每一个运行单元的总收益，当前的信号、下单、持仓、持仓盈亏等数据一目了然。
                </div>
                <div class="paragraph">
                  模组还支持收益分析、资金管理、手动加减仓干预等功能。
                </div>
                <div class="case_box">
                  <div class="first">案例：模型运行管理界面详解</div>

                  <BaseBigimg
                    :src="require('./imageswh9/img23.jpg')"
                  ></BaseBigimg>
                  <div class="first">模型运行管理界面名词解释：</div>
                  <div class="paragraph_box">
                      <div class="paragraph">
                        <span class="first">单元：</span
                        >模组中每个运行的模型称为单元。
                      </div>
                      <div class="paragraph">
                        <span class="first">分区：</span
                        >多个运行单元可分配到同一工作区内，进行分区管理。
                      </div>
                      <div class="paragraph">
                        <span class="first">监控k线图：</span
                        >显示该模型数据合约的k线图，支持显示模型信号、实际收益曲线、原型指标线。
                      </div>
                      <div class="paragraph">
                        <span class="first">模型参数：</span
                        >显示模型参数，并支持手动修改参数并启用新参数重新计算。
                      </div>
                      <div class="paragraph">
                        <span class="first">交易合约：</span
                        >支持查看数据合约、交易合约，并支持修改交易合约。
                      </div>
                      <div class="paragraph">
                        <span class="first">源码：</span
                        >显示模型源码，支持设置查看密码，隐藏交易源码。
                      </div>
                      <div class="paragraph">
                        <span class="first">撤单/手动追价：</span
                        >当模型委托不成交产生挂单时，可以手动撤单，或者进行追价。
                      </div>
                      <div class="paragraph">
                        <span class="first">导入账户持仓：</span
                        >单元持仓小于理论持仓且实际账户中有持仓时，可在模组里点击“导入账户持仓”按钮，将实际账户中已有的持仓带入到模组中。
                      </div>
                      <div class="paragraph">
                        <span class="first">加仓/减仓：</span
                        >支持手动对该模组单元进行加仓、减仓操作。
                      </div>
                      <div class="paragraph">
                        <span class="first">平移到新合约：</span
                        >用于换月移仓操作，将旧主力合约平仓以后，点击“平移到新合约”按钮，选择新主力合约，系统延续模型单元的资金，在新主力合约上重新计算信号并继续交易。
                      </div>
                      <div class="paragraph">
                        <span class="first">运行日志：</span
                        >显示该模型单元的运行日志。
                      </div>
                      <div class="paragraph">
                        <span class="first">成交列表/持仓列表：</span
                        >显示该模型单元的成交情况和当前持仓情况。
                      </div>
                  </div>
                </div>
              </div>
              <div v-if="id == 6 && tabId == 1">
                
                <div class="paragraph">
                  <common-data name="appShortName_17"/>支持对模型设置查看密码，以及加密输出执行副本，在模型配置以及模型运行过程中，都无法直接查看模型源码，保证模型的安全性。
                </div>
                <div class="case_box">
                  <div class="first">案例：模型加密运行过程详解</div>
                  <div class="paragraph">
                    在模型编辑界面，可点击【设置】，选择设置查看密码，输入密码以后，该模型在编辑和加载运行时，都不会显示模型源码，保证模型安全运行。
                  </div>

                  <BaseBigimg
                    :src="require('./imageswh9/img21.jpg')"
                  ></BaseBigimg>

                  <div class="paragraph">
                    模型加载以后，只能看到信号和运行结果，不显示模型源码。
                  </div>

                  <BaseBigimg
                    :src="require('./imageswh9/img22.jpg')"
                  ></BaseBigimg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="loading" v-if="showloading">
      <img src="../assets/img/loading.gif" alt="" style="position:absolute;top:42%;left:50%;">
    </div> -->
    <!-- <BaseHover :message="message" v-show="!!message" class="basehover" :style="{left:left+'px',top:top+'px'}"></BaseHover>
    <BaseAlert @close="close" v-if="showalert"></BaseAlert> -->
  </div>
</template>
<script>
import axios from "axios";
import Svgg from "../../components/Svgg.vue";
import Basecharts from "../../components/Basecharts.vue";
import BaseHover from "../../components/BaseHover.vue";
import BaseAlert from "../../components/BaseAlert.vue";

export default {
  components: {
    Basecharts,
    BaseHover,
    BaseAlert,
    Svgg,
  },
  watch: {
    // "currentComponent": {
    //   handler: function (newd) {
    //     console.log(newd)
    //     console.log(document.documentElement.getElementsByClassName('img_center')[0])
    //   },
    //   deep:true,
    //   immediate:true,
    // },
    "$route.query.id": {
      handler: function (newd) {
        console.log(newd);
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    console.log(this.$route.query.id);
  },
  data() {
    return {
      id: 0,
      tabList: [],
      tabId: 0,
      showcode: [false,false,false,false],
      show: [false, false, false, false, false],
      contentList1: [
        {
          name: "趋势策略研发",
          tab: [
            {
              name: "超长的、准确的样本数据",
              tabId: 0,
            },
            {
              name: "主连链回测",
              tabId: 1,
            },
            {
              name: "360度视角回测报告",
              tabId: 2,
            },
          ],
          id: 0,
        },
        {
          name: "订单流策略研发",
          tab: [
            {
              name: "可视化回测平台",
              tabId: 0,
            },
            {
              name: "仿真撮合机制",
              tabId: 1,
            },
          ],
          id: 1,
        },
        {
          name: "算法交易策略研发",
          tab: [
            {
              name: "模型信号算法交易",
              tabId: 0,
            },
            {
              name: "手动下单算法交易",
              tabId: 1,
            },
          ],
          id: 2,
        },
      ],
      contentList2:[
        {
          name: "组合配置与定参",
          tab: [
            {
              name: "组合配置",
              tabId: 0,
            },
            {
              name: "组合参数优化",
              tabId: 1,
            },
          ],
          id: 3,
        },
        {
          name: "资金管理",
          tab:[],
          id: 4,
        },
        {
          name: "收益分析",
          tab:[],
          id: 5,
        },],
        
        contentList3:[
        {
          name: "模型运行监控",
          tab: [
            {
              name: "模型运行管理中心",
              tabId: 0,
            },
            {
              name: "模型加密运行",
              tabId: 1,
            },
          ],
          id: 6,
        },
      ],
    };
  },
  mounted() {
    this.selectContent(this.contentList1[0]);
  },
  methods: {
    dropdowncode(idx){
      this.$set(this.showcode,idx,!this.showcode[idx])
    },
    selectContent(item) {
      this.id = item.id;
      this.tabId = 0;
      this.tabList = item.tab;
    },
    choosetag(id) {
      this.tabId = id;
    },
    showImg(id) {
      this.show[id] = !this.show[id];
      console.log(this.show);
      this.$forceUpdate();
    },
  },
};
</script>
<style scoped src="./index.css"></style>
<style scoped>
.trans {
  transform: rotate(180deg);
}
.container {
  padding-top: 50px;
  height: 100%;
  min-height: 400px;
  background: url(https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=82) no-repeat top,
    url(../../assets/img/bgonepp.jpg) repeat-y center top 1134px;
  text-align: left;
}
.loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.2);
  z-index: 999;
}
.content {
  color: rgb(132, 133, 135);
  border-radius: 10px 10px 0 0;
  width: 100%;
  height: 100%;
  min-height: 600px;
  /* margin-left: 40px; */
  background: #fff;
  box-shadow: -1px 0px 3px 0px rgba(209, 222, 238, 0.9);
  
  font-size: 17px;
}
.tab ul li {
  width: 160px;
}
/* .tab {
  width: 180px;
}
.tab_title {
  font-size: 20px;
  font-weight: 570;
  line-height: 40px;
  padding-left: 8px;
  color: #323232;
  margin-top: 25px;
}
.underline {
  width: 30px;
  height: 2px;
  background: #323232;
  margin-left: 8px;
}
.tab ul {
  margin-top: 20px;
}
.tab ul li {
  color: #808080;
  height: 34px;
  line-height: 34px;
  font-size: 16px;
  width: 160px;
  padding-left: 17px;
  background: transparent;
  cursor: pointer;
  margin-bottom: 10px;
  border-radius: 0 50px 50px 0;
  padding-right: 18px;
}
.tab ul li:hover {
  color: #3b78f7;
 
}
.tab ul li.active {
  color: #3b78f7;
  background-image: linear-gradient(90deg, #f9feff, #e9f6ff, #dfebf7);
  background-image: -moz-linear-gradient(90deg, #f9feff, #e9f6ff, #dfebf7);
  box-shadow: #d1d6e5 1px 1px 5px 2px;
  
} */
.text-first {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  /* width: 1096px; */
  margin: 0 60px;
  margin-top:20px;
}
.text-txt {
  padding-top: 5px;
  font-size: 15px;
  min-height: 600px;
  background: #f6f9fe;
  
  padding-bottom: 40px;
  border-radius: 10px 10px 0 0;
}
.tit-left {
  display: flex;
  flex-direction: row;
}
.right-tip {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 1005px;
  margin: 0 auto;
  cursor: pointer;
}
.right-tip div {
  padding: 2px 4px;
}
/* .right-tip div.active{
  color: white;
  background: #4b63f7;
} */
.tit-left-item {
  cursor: pointer;
  /* padding: 6px 18px; */
  position: relative;
  color: #181818;
}
/* .tit-left-item.active{
  color: #4b63f7;
  border-bottom: 3px solid #4b63f7;
} */
.txt-left-item {
  cursor: pointer;
  margin: 0 18px;
  padding: 3px 0px;
  font-size: 16px;
}
.txt-left-item:hover {
  color: #536b99;
}
.txt-left-item.active {
  color: #5268cd;
  border-bottom: 3px solid #5268cd;
  font-weight: bold;
}
.txt-img {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 1029px;
  margin: 0 auto;
  margin-top: 5px;
}
.base-ech {
  margin: 0px 12px;
  margin-bottom: 26px;
}
.txt-first {
  display: flex;
  flex-direction: row;
  /* margin-left: 50px; */
}
.txt-table {
  margin-top: 5px;
}
.gongshiTable {
  text-align: justify;
  line-height: 30px;
  width: 630px;
  margin: 0 auto;
}
.gongshiTable tr:nth-of-type(2n + 1) {
  background-color: #efefef;
}
.gongshiTable tr:nth-of-type(2n) {
  background-color: #ffffff;
}
.gongshiTable tr td {
  padding-left: 10px;
}
.gongshiTable img {
  width: auto !important;
  height: auto !important;
  background-color: transparent !important;
}
.timeTable {
  width: 100%;
  border-collapse: collapse;
  width: 700px;
  margin: 0 auto;
  text-align: left;
  font-size: 14px;
}
.timeTable th {
  text-align: center;
  border: 1px solid #d8d7d7;
  padding: 5px 0;
}
.timeTable td {
  border: 1px solid #d8d7d7;
  padding-left: 5px;
}
.timeTable td:nth-child(-n + 2) {
  background-color: #fffbed;
}
.timeTable th:nth-child(-n + 2) {
  background-color: #f7e9ba;
}
.timeTable td:nth-child(3),
.timeTable td:nth-child(4) {
  background-color: #f4fffe;
}
.timeTable th:nth-child(3),
.timeTable th:nth-child(4) {
  background-color: #96d2ce;
}
.timeTable td:nth-child(5),
.timeTable td:nth-child(6) {
  background-color: #fff9fa;
}
.timeTable th:nth-child(5),
.timeTable th:nth-child(6) {
  background-color: #ecccd0;
}
.timeTable td:nth-last-child(-n + 2) {
  background-color: #f4f6fd;
}
.timeTable th:nth-last-child(-n + 2) {
  background-color: #a7b9e4;
}
.expand {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 200px;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  text-indent: 0em !important;
  font-weight: bolder;
}
.extendBtn,
.extendCodeBtn {
  font-size: 14px;
  cursor: pointer;
  text-align: center;
  text-indent: 0em !important;
  color: #0f5da2 !important;
  position: relative;
}
.extendBtn::after,
.extendCodeBtn::after {
  content: ">";
  color: #0f5da2 !important;
  font-size: 14px;
  position: absolute;
  right: -15px;
  top: 2px;
  -webkit-transform: rotate(-90deg);
  -ms-transform: rotate(-90deg);
  transform: rotate(-90deg);
  -moz-transform: rotate(-90deg);
  -o-transform: rotate(-90deg);
}
.extendBtn.active::after,
.extendCodeBtn.active::after {
  transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -o-transform: rotate(90deg);
}

.solution_download {
    color: #012f6d;
    cursor: pointer;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: end;
        -ms-flex-pack: end;
            justify-content: flex-end;
    height: 48px;
}
.solution_download img {
    margin-right: -25px;
}
.solution_download>div {
   
    text-align: justify;
    font-size: 14px;
    text-indent: 2em;
}
.solution_download  a {
    text-decoration: none;
    color: #3983F3;
}
.tabtitle {
    font-size: 16px;
    font-weight: bolder;
    position: relative;
    margin: 13px 0 10px 17px;
}
.tabtitle::before {
    content: '';
    height: 17px;
    width: 3px;
    background-color: #105DA2;
    position: absolute;
    top: 2.5px;
    left: -10px;
}
.paragraph_box .first {
    line-height: 28px;
}
</style>